/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common = __webpack_require__(2);
	var router = __webpack_require__(31);
	var init = __webpack_require__(32);
	var MaApp;
	(function (MaApp) {
	    var ngModule = angular.module('ma', [
	        'ui.router',
	        'ui.bootstrap',
	        'pascalprecht.translate',
	        'ngCookies',
	        'ui.grid',
	        'ui.grid.pagination',
	        'ui.grid.resizeColumns',
	        'ui.grid.selection',
	        'ghiscoding.validation',
	        'ui.sortable',
	        'ui.sortable.multiselection',
	        'ngFileUpload'
	    ]);
	    // 共通部品のクラスの登録処理の呼び出し
	    common.init(ngModule);
	    // 各業務のクラスの登録処理の呼び出し
	    init.init(ngModule);
	    // 画面遷移定義の呼び出し
	    ngModule.config(config);
	    ngModule.config(router.config);
	    // 共通設定の呼び出し
	    ngModule.config(common.config);
	    ngModule.run(run);
	    /* @ngInject */
	    function config($urlRouterProvider) {
	        // デフォルトURLルーティング設定
	        $urlRouterProvider.otherwise('/');
	    }
	    /* @ngInject */
	    function run($translate) {
	        $translate.use('ja');
	    }
	})(MaApp || (MaApp = {}));
	if (!String.prototype.startsWith) {
	    String.prototype.startsWith = function (searchString, position) {
	        position = position || 0;
	        return this.indexOf(searchString, position) === position;
	    };
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var init_1 = __webpack_require__(3);
	exports.init = init_1.init;
	var config_1 = __webpack_require__(29);
	exports.config = config_1.config;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var UserApi_1 = __webpack_require__(4);
	var AuthenticationService_1 = __webpack_require__(5);
	var AuthenticationCheckService_1 = __webpack_require__(16);
	var HistoryApi_1 = __webpack_require__(17);
	var HistoryService_1 = __webpack_require__(18);
	var LocalityApi_1 = __webpack_require__(19);
	var LocalityService_1 = __webpack_require__(20);
	var HeaderController_1 = __webpack_require__(21);
	var SystemErrorController_1 = __webpack_require__(23);
	var ConfirmDlgController_1 = __webpack_require__(24);
	var NoticeDlgController_1 = __webpack_require__(25);
	var CommonConst_1 = __webpack_require__(26);
	var PjInjectProxyImpl_1 = __webpack_require__(27);
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * 共通部品のコンポーネントを登録する
	 * @param {ng.IModule} angularModule AngularJSのモジュール
	 */
	function init(angularModule) {
	    angularModule
	        .factory('userApi', function ($http, $httpParamSerializer) {
	        return new UserApi_1.UserApi($http, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH);
	    })
	        .factory('historyApi', function ($http, $httpParamSerializer) {
	        return new HistoryApi_1.HistoryApi($http, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH);
	    })
	        .factory('localityApi', function ($http, $httpParamSerializer) {
	        return new LocalityApi_1.LocalityApi($http, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH);
	    })
	        .service('authenticationService', AuthenticationService_1.AuthenticationService)
	        .service('authenticationCheckService', AuthenticationCheckService_1.AuthenticationCheckService)
	        .service('historyService', HistoryService_1.HistoryService)
	        .service('localityService', LocalityService_1.LocalityService)
	        .service('pjInjectProxy', PjInjectProxyImpl_1.PjInjectProxyImpl)
	        .service('sharedService', PjBaseController_1.SharedService)
	        .controller('SystemErrorController', SystemErrorController_1.SystemErrorController)
	        .controller('HeaderController', HeaderController_1.HeaderController)
	        .controller('ConfirmDlgController', ConfirmDlgController_1.ConfirmDlgController)
	        .controller('NoticeDlgController', NoticeDlgController_1.NoticeDlgController);
	}
	exports.init = init;


/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var UserApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function UserApi($http, $httpParamSerializer, basePath) {
	        this.$http = $http;
	        this.$httpParamSerializer = $httpParamSerializer;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * 認証
	     * ユーザのログイン処理を行い、ログイン結果を取得する（ログイン成功：true, ログイン失敗：false）。また、ログイン成功時には合わせてユーザ情報を取得する
	     * @param userid  ユーザID
	     * @param password  パスワード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.userPost = function (userid, password, isDbl) {
	        if (isDbl === void 0) { isDbl = false; }
	        var path = this.basePath + '/user';
	        var queryParameters = {};
	        var formParams = {};
	        var headerParams = {
	            'Content-Type': 'application/x-www-form-urlencoded'
	        };
	        formParams['userid'] = userid;
	        formParams['password'] = password;
	        var httpRequestParams = {
	            method: 'POST',
	            url: path,
	            params: queryParameters,
	            data: this.$httpParamSerializer(formParams),
	            headers: headerParams,
	            unique: isDbl,
	            screenId: path
	        };
	        return this.$http(httpRequestParams);
	    };
	    /**
	     * ユーザ情報取得
	     * ユーザの情報を取得する
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.userGet = function (isDbl) {
	        if (isDbl === void 0) { isDbl = false; }
	        var path = this.basePath + '/user';
	        var queryParameters = {};
	        var httpRequestParams = {
	            method: 'GET',
	            url: path,
	            params: queryParameters,
	            unique: isDbl,
	            screenId: path
	        };
	        return this.$http(httpRequestParams);
	    };
	    /**
	     * 認証状態チェック
	     * 認証状態をチェックする。認証されていればtrue, 認証されていなければ（セッションタイムアウト含む）falseを返す
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.userStateGet = function (isDbl) {
	        if (isDbl === void 0) { isDbl = false; }
	        var path = this.basePath + '/user/state';
	        var queryParameters = {};
	        var httpRequestParams = {
	            method: 'GET',
	            url: path,
	            params: queryParameters,
	            unique: isDbl,
	            screenId: path
	        };
	        return this.$http(httpRequestParams);
	    };
	    return UserApi;
	}());
	exports.UserApi = UserApi;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * ユーザの認証情報を管理する。
	 */
	var AuthenticationService = (function (_super) {
	    __extends(AuthenticationService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {UserApi} userApi ユーザ認証API
	     */
	    /* @ngInject */
	    function AuthenticationService($q, userApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.userApi = userApi;
	    }
	    /**
	     * ログイン
	     * @param {string} userId ユーザID
	     * @param {string} password パスワード
	     * @return {ng.IPromise<PjServiceResponse<LoginResult>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、ログインの認証結果となる。
	     */
	    AuthenticationService.prototype.login = function (userId, password) {
	        var _this = this;
	        var deferred = this.$q.defer();
	        this.userApi
	            .userPost(userId, password)
	            .success(function (data, status, headers, config) {
	            // ユーザの情報をsessionStorageへ格納する(共通ヘッダで表示するため)
	            if (data.result) {
	                _this.user = data.user;
	            }
	            var result = {
	                result: data.result,
	                user: _this.user
	            };
	            // 必要があればレスポンスデータの加工を実施
	            deferred.resolve({ status: status, data: result });
	        })
	            .error(function (data, status, headers, config) {
	            deferred.reject({ status: status, error: data });
	        });
	        return deferred.promise;
	    };
	    /**
	     * ユーザ情報取得
	     * @return {ng.IPromise<PjServiceResponse<User>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、ユーザ情報となる。
	     */
	    AuthenticationService.prototype.getUser = function () {
	        var _this = this;
	        var deferred = this.$q.defer();
	        if (!this.user) {
	            // キャッシュに格納されていなければ取得する
	            // 同時にアクセスにきたことを考慮し、2重送信チェックを追加
	            this.userApi
	                .userGet(true)
	                .success(function (data, status, headers, config) {
	                // 取得できた場合、ユーザの情報を格納
	                if (data) {
	                    _this.user = data.user;
	                    deferred.resolve({ status: status, data: _this.user });
	                }
	            })
	                .error(function (data, status, headers, config) {
	                deferred.reject({ status: status, error: data });
	            });
	        }
	        else {
	            // キャッシュから返す
	            deferred.resolve({ status: 200, data: this.user });
	        }
	        return deferred.promise;
	    };
	    /**
	     * 認証状態チェック
	     * @return {ng.IPromise<PjServiceResponse<boolean>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、ユーザの認証状態(true:認証済み/false：未認証）となる。
	     */
	    AuthenticationService.prototype.isAuthenticated = function () {
	        var deferred = this.$q.defer();
	        this.userApi
	            .userStateGet(true)
	            .success(function (data, status, headers, config) {
	            // ユーザの情報をsessionStorageへ格納する(共通ヘッダで表示するため)
	            deferred.resolve({ status: status, data: data.result });
	        })
	            .error(function (data, status, headers, config) {
	            deferred.reject({ status: status, error: data });
	        });
	        return deferred.promise;
	    };
	    return AuthenticationService;
	}(PjBaseService_1.PjBaseService));
	exports.AuthenticationService = AuthenticationService;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var framework = __webpack_require__(7);
	/**
	 * プロジェクト向け基盤Service
	 */
	var PjBaseService = (function (_super) {
	    __extends(PjBaseService, _super);
	    /**
	     * @constructor
	     * @param {ng.IHttpService} $http - http
	     */
	    function PjBaseService($http) {
	        _super.call(this, $http);
	        this.$http = $http;
	    }
	    /**
	     * サーバからデータを取得する（検索およびデータ取得に使用）
	     * @param {string} url リクエスト先URL
	     * @param {pjfw.PjBaseReq} params - リクエストパラメータ
	     * @param {boolean} unique - 2重送信の抑止の設定(true：抑止, false：抑止しない）
	     * @return {ng.IHttpPromise} 実行結果のプロミス
	     */
	    PjBaseService.prototype.get = function (url, params, unique) {
	        if (unique === void 0) { unique = true; }
	        // configを設定する
	        var config = {};
	        config['unique'] = unique;
	        config['screenId'] = url;
	        // パラメータの組み立て
	        var param = '', keys = Object.keys(params), length = keys.length;
	        for (var i = 0; i < length; i++) {
	            param = param + keys[i] + '=' + params[keys[i]] + '&';
	        }
	        // 末尾の&を削除する
	        param = param.substring(0, param.length - 1);
	        // GETでの通信処理
	        return this.$http.get(url + '?' + param, config);
	    };
	    /**
	     * サーバのデータを更新する
	     * 送信の種類はPOST
	     * @param {string} url url
	     * @param {string} params リクエストパラメータ
	     * @param {boolean} unique - 2重送信の抑止の設定(true：抑止, false：抑止しない）
	     * @return {ng.IHttpPromise} 実行結果のプロミス
	     */
	    PjBaseService.prototype.post = function (url, params, unique) {
	        if (unique === void 0) { unique = true; }
	        // configを設定する
	        var config = {};
	        config['unique'] = unique;
	        config['screenId'] = url;
	        // POSTでの通信処理
	        return this.$http.post(url, params, config);
	    };
	    /**
	     * サービスの初期化時（アプリの起動時）にエラーが発生したときの通知を行う
	     *
	     */
	    PjBaseService.prototype.noticeStartupError = function (status) {
	        // クライアント側で読み込みを中断したときに表示しないように変更
	        if (status !== -1) {
	            alert('システムの起動時にエラーが発生しました。再読み込みしてください。再読み込み後も問題が解決しない場合は、管理者にお問い合わせください。');
	        }
	    };
	    return PjBaseService;
	}(framework.BaseService));
	exports.PjBaseService = PjBaseService;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(8));
	__export(__webpack_require__(12));
	__export(__webpack_require__(10));
	var interceptor_1 = __webpack_require__(14);
	exports.interceptor = interceptor_1.interceptor;
	var config_1 = __webpack_require__(15);
	exports.config = config_1.config;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(9));
	__export(__webpack_require__(11));


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var BaseConst_1 = __webpack_require__(10);
	/**
	 * 基盤Controller
	 */
	var BaseController = (function () {
	    /**
	     * コンストラクタ
	     * パラメータでプロパティの定義を実施
	     * @param {angular.ui.IStateParamsService} $stateParams UI Routerのパラメータ
	     * @param {BaseInjectProxy} baseInjectProxy フレームワークで使用するサービス
	     */
	    function BaseController($stateParams, $translate, baseInjectProxy) {
	        this.$stateParams = $stateParams;
	        this.$translate = $translate;
	        /**
	         * フレームワークで使用するサービスのプロキシ
	         */
	        this.PATTERN_NUMBER = 'pattern=/^[0-9]*$/:alt=半角数字を入力してください。';
	        this.PATTERN_SINGLE = 'pattern=/^[a-zA-Z0-9!-/:-@<C2><A5>[-`{-~]*$/:alt=半角文字を入力してください。';
	        this.PATTERN_PASSWORD = 'pattern=/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\\d)[a-zA-Z\\d]{8,100}$/:alt=半角英小文字大文字数字をそれぞれ1種類以上含む8文字以上のパスワードを入力してください。';
	        this.baseInjectProxyImpl = baseInjectProxy;
	    }
	    /**
	     * 画面のタイトルを設定する
	     * @param {string} title タイトル
	     */
	    BaseController.prototype.setTitle = function (title) {
	        var _this = this;
	        this.$translate(title).then(function (value) {
	            _this.baseInjectProxyImpl.getRootScope()[BaseConst_1.BaseConst.SCOPE_TITLE] = value;
	        });
	    };
	    /** 描画処理
	     * カウンタのIDに合わせて処理を分岐
	     * @param {any} history 履歴への追加するデータ 存在する場合は履歴へ追加
	     */
	    BaseController.prototype.draw = function (history) {
	        var _this = this;
	        if (history === void 0) { history = null; }
	        if (this.$stateParams) {
	            var fwts_1 = this.$stateParams[BaseConst_1.BaseConst.PARAM_TIMESTAMP];
	            if (fwts_1) {
	                // 存在する場合、画面のリストア
	                this.getHistory(fwts_1).then(function (response) {
	                    if (response) {
	                        _this.restore(response);
	                    }
	                    else {
	                        _this.show();
	                        if (history) {
	                            _this.addHistory(fwts_1, history);
	                        }
	                    }
	                });
	            }
	            else {
	                // 存在しない場合は、通常の表示
	                this.show();
	            }
	        }
	        else {
	            this.show();
	        }
	    };
	    /**
	     * UI Routerの画面遷移のラッパー
	     * （カウンターの埋め込みを実施）
	     * @param {string} state 遷移先の状態
	     * @param {any} params パラメータ
	     */
	    BaseController.prototype.go = function (state, params) {
	        if (params === void 0) { params = {}; }
	        params[BaseConst_1.BaseConst.PARAM_TIMESTAMP] = new Date().getTime();
	        this.baseInjectProxyImpl.getState().go(state, params);
	    };
	    /**
	     * 現在の画面遷移のステータス名を取得する
	     * @return {string} ステータス名
	     */
	    BaseController.prototype.getCurrentStatus = function () {
	        return this.baseInjectProxyImpl.getState().current.name;
	    };
	    return BaseController;
	}());
	exports.BaseController = BaseController;


/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * フレームワークの定数
	 */
	var BaseConst;
	(function (BaseConst) {
	    /**
	     * タイトル格納用
	     */
	    BaseConst.SCOPE_TITLE = 'title';
	    /**
	     * 履歴管理用のパラメータ名
	     */
	    BaseConst.PARAM_TIMESTAMP = 'fwts';
	})(BaseConst = exports.BaseConst || (exports.BaseConst = {}));


/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * メッセージのレベル（種別）定義
	 */
	var MsgLevel = (function () {
	    function MsgLevel() {
	    }
	    /**
	     * 情報
	     */
	    MsgLevel.INFO = 'info';
	    /**
	     * 警告
	     */
	    MsgLevel.WARNING = 'warning';
	    /**
	     * エラー（危険）
	     */
	    MsgLevel.ERROR = 'danger';
	    /**
	     * 成功
	     */
	    MsgLevel.SUCCESS = 'success';
	    return MsgLevel;
	}());
	exports.MsgLevel = MsgLevel;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(13));


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * 基盤Service
	 */
	var BaseService = (function () {
	    /**
	     * @constructor
	     * @param {ng.IHttpService} $http - http
	     */
	    function BaseService($http) {
	        this.$http = $http;
	    }
	    return BaseService;
	}());
	exports.BaseService = BaseService;


/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * ２重送信防止処理
	 * ($httpProviderがもつ配列interceptorsに以下factoryを追加して
	 *  サーバに引き渡される前のリクエストの前処理(２重送信防止処理)を定義する。）
	 */
	/* @ngInject */
	function interceptor($q, $injector) {
	    return {
	        request: function (config) {
	            var $http = $injector.get('$http');
	            function checkForDuplicates(config2) {
	                return !!config2['unique'];
	            }
	            function checkIfDuplicated(config3) {
	                var duplicated = $http.pendingRequests.filter(function (pendingConfig) {
	                    return pendingConfig['screenId'] && pendingConfig['screenId'] === config3['screenId'];
	                });
	                return duplicated.length > 0;
	            }
	            function buildRejectedRequestPromise(config4) {
	                var dfd = $q.defer(), reason = { data: {}, headers: {}, status: 499, config: config4 };
	                dfd.reject(reason);
	                return dfd.promise;
	            }
	            if (checkForDuplicates(config) && checkIfDuplicated(config)) {
	                return buildRejectedRequestPromise(config);
	            }
	            return config || $q.when(config);
	        }
	    };
	}
	exports.interceptor = interceptor;
	;


/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * FWの共通的な設定を行う
	 * @param {ng.IModule} angularModule AngularJSのモジュール
	 */
	function config($httpProvider) {
	    // Httpヘッダーにno-cacheを追加
	    if (!$httpProvider.defaults.headers.get) {
	        $httpProvider.defaults.headers.get = {};
	    }
	    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
	    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
	    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
	}
	exports.config = config;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * ユーザの認証情報をチェックし、表示するテンプレートを選定する
	 */
	var AuthenticationCheckService = (function (_super) {
	    __extends(AuthenticationCheckService, _super);
	    /**
	     * コンストラクタ
	     * @param {any} $templateFactory テンプレートファクトリー
	     * @param {ng.IWindowService} $window Windowサービス
	     * @param {AuthenticationService} authenticationService ユーザ認証サービス
	     */
	    /* @ngInject */
	    function AuthenticationCheckService($templateFactory, $window, authenticationService) {
	        _super.call(this, null);
	        this.$templateFactory = $templateFactory;
	        this.$window = $window;
	        this.authenticationService = authenticationService;
	    }
	    /**
	     * 認証状態チェック
	     * @param {string} templateUrl テンプレートURL
	     * @return {ng.IPromise<string>} 画面に表示するテンプレートを返す。認証済み：パラメータのテンプレート、未認証：空文字
	     */
	    AuthenticationCheckService.prototype.isAuthenticated = function (templateUrl) {
	        var _this = this;
	        return this.authenticationService.isAuthenticated().then(function (res) {
	            if (res.data) {
	                return _this.$templateFactory.fromUrl(templateUrl);
	            }
	            _this.$window.location.href = '../login/index.html#/';
	            return '';
	        })
	            .catch(function (res) {
	            _this.$window.location.href = '../login/index.html#/';
	            return '';
	        });
	    };
	    return AuthenticationCheckService;
	}(PjBaseService_1.PjBaseService));
	exports.AuthenticationCheckService = AuthenticationCheckService;


/***/ },
/* 17 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var HistoryApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function HistoryApi($http, $httpParamSerializer, basePath) {
	        this.$http = $http;
	        this.$httpParamSerializer = $httpParamSerializer;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * 履歴一覧追加
	     * 履歴のタイムスタンプ一覧を取得する。
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    HistoryApi.prototype.historyGet = function (isDbl) {
	        if (isDbl === void 0) { isDbl = false; }
	        var path = this.basePath + '/history';
	        var queryParameters = {};
	        var httpRequestParams = {
	            method: 'GET',
	            url: path,
	            params: queryParameters,
	            unique: isDbl,
	            screenId: path
	        };
	        return this.$http(httpRequestParams);
	    };
	    /**
	     * 履歴追加
	     * 画面復元用の履歴を格納する。
	     * @param timestamp  タイムスタンプ
	     * @param data  格納データ
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    HistoryApi.prototype.historyPut = function (timestamp, data, isDbl) {
	        if (isDbl === void 0) { isDbl = false; }
	        var path = this.basePath + '/history';
	        var queryParameters = {};
	        var formParams = {};
	        var headerParams = {
	            'Content-Type': 'application/x-www-form-urlencoded'
	        };
	        formParams['timestamp'] = timestamp;
	        formParams['data'] = data;
	        var httpRequestParams = {
	            method: 'PUT',
	            url: path,
	            params: queryParameters,
	            data: this.$httpParamSerializer(formParams),
	            headers: headerParams,
	            unique: isDbl,
	            screenId: path
	        };
	        return this.$http(httpRequestParams);
	    };
	    /**
	     * 履歴取得
	     * 指定したタイムスタンプの履歴を取得する。
	     * @param timestamp  タイムスタンプ
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    HistoryApi.prototype.historyTimestampGet = function (timestamp, isDbl) {
	        if (isDbl === void 0) { isDbl = false; }
	        var path = this.basePath + '/history/{timestamp}'
	            .replace('{' + 'timestamp' + '}', String(timestamp));
	        var queryParameters = {};
	        var httpRequestParams = {
	            method: 'GET',
	            url: path,
	            params: queryParameters,
	            unique: isDbl,
	            screenId: path
	        };
	        return this.$http(httpRequestParams);
	    };
	    return HistoryApi;
	}());
	exports.HistoryApi = HistoryApi;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * 画面遷移の履歴を管理する。サーバへの履歴の送信、サーバからの履歴の取得を行う。
	 */
	var HistoryService = (function (_super) {
	    __extends(HistoryService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {HistoryApi} historyApi 履歴管理Api
	     */
	    /* @ngInject */
	    function HistoryService($q, historyApi) {
	        var _this = this;
	        _super.call(this, null);
	        this.$q = $q;
	        this.historyApi = historyApi;
	        /**
	         * タイムスタンプ
	         */
	        this.timestamps = {};
	        // 初回読み込み時にサーバ側のステータスを取得する必要あり
	        if (!this.state) {
	            this.historyApi.historyGet(true)
	                .success(function (res, status, headers, config) {
	                _this.state = res.state;
	                for (var i = 0; i < res.timestamps.length; i++) {
	                    _this.timestamps[res.timestamps[i].timstamp] = true;
	                }
	            })
	                .error(function (data, status, headers, config) {
	                _this.noticeStartupError(status);
	            });
	        }
	    }
	    /**
	     * 履歴送信
	     * @param {string} timestamp タイムスタンプ
	     * @param {any} data 履歴データ
	     */
	    HistoryService.prototype.addHistory = function (timestamp, data) {
	        // タイムスタンプを保持する
	        this.timestamps[timestamp] = true;
	        // サーバへ送信
	        this.historyApi.historyPut(timestamp, JSON.stringify(data), true)
	            .success(function (res, status, headers, config) {
	        })
	            .error(function (dataErr, status, headers, config) {
	        });
	    };
	    /**
	     * 履歴取得
	     * @param {string} state ステータス
	     * @return {ng.IPromise<PjServiceResponse<string>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、履歴データとなる。
	     */
	    HistoryService.prototype.getHistory = function (state) {
	        var _this = this;
	        var deferred = this.$q.defer();
	        if (this.state !== state) {
	            this.historyApi.historyTimestampGet(state, true)
	                .success(function (res, status, headers, config) {
	                _this.state = state;
	                _this.data = res.data;
	                deferred.resolve({ status: status, data: JSON.parse(res.data) });
	            })
	                .error(function (data, status, headers, config) {
	                deferred.reject({ status: status, error: data });
	            });
	        }
	        else {
	            deferred.resolve({ status: 200, data: this.data });
	        }
	        return deferred.promise;
	    };
	    /**
	     * タイムスタンプチェック
	     * @param {string} timestamp タイムスタンプ
	     * @return {boolean} タイムスタンプがある場合：true, タイムスタンプがない場合：false
	     */
	    HistoryService.prototype.contains = function (timestamp) {
	        if (this.timestamps[timestamp]) {
	            return true;
	        }
	        return false;
	    };
	    return HistoryService;
	}(PjBaseService_1.PjBaseService));
	exports.HistoryService = HistoryService;


/***/ },
/* 19 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var LocalityApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function LocalityApi($http, $httpParamSerializer, basePath) {
	        this.$http = $http;
	        this.$httpParamSerializer = $httpParamSerializer;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * 自治体一覧取得
	     * 自治体にある図書館の情報を取得(検索)する。
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    LocalityApi.prototype.localityGet = function (isDbl) {
	        if (isDbl === void 0) { isDbl = false; }
	        var path = this.basePath + '/locality';
	        var queryParameters = {};
	        var httpRequestParams = {
	            method: 'GET',
	            url: path,
	            params: queryParameters,
	            unique: isDbl,
	            screenId: path
	        };
	        return this.$http(httpRequestParams);
	    };
	    return LocalityApi;
	}());
	exports.LocalityApi = LocalityApi;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * 自治体に関するデータを管理するサービスである。
	 */
	var LocalityService = (function (_super) {
	    __extends(LocalityService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {LocalityApi} localityApi 自治体Api
	     */
	    /* @ngInject */
	    function LocalityService($q, localityApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.localityApi = localityApi;
	    }
	    /**
	     * 自治体一覧取得
	     * @return {ng.IPromise<PjServiceResponse<Locality[]>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、図書館の一覧となる。
	     */
	    LocalityService.prototype.getLocality = function () {
	        var _this = this;
	        var deferred = this.$q.defer();
	        if (!this.locality) {
	            // キャッシュに格納されていなければ取得する
	            // 同時にアクセスにきたことを考慮し、2重送信チェックを追加
	            this.localityApi.localityGet(true).success(function (res, status, headers, config) {
	                // キャッシュにデータを格納
	                _this.locality = res.localitys;
	                deferred.resolve({ status: status, data: _this.locality });
	            }).error(function (data, status, headers, config) {
	                deferred.reject({ status: status, error: data });
	            });
	        }
	        else {
	            // キャッシュから返す
	            deferred.resolve({ status: 200, data: this.locality });
	        }
	        return deferred.promise;
	    };
	    return LocalityService;
	}(PjBaseService_1.PjBaseService));
	exports.LocalityService = LocalityService;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * システムヘッダの画面領域について出力処理およびイベント処理を行う。
	 */
	var HeaderController = (function (_super) {
	    __extends(HeaderController, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IWindowService} $window windowサービスの機能
	     * @param {ng.ui.bootstrap.IModalService} $uibModal モーダル
	     * @param {ng.translate.ITranslateService} $translate angular-templateのサービス
	     * @param {PjInjectProxy} pjInjectProxy インジェクタプロキシ
	     * @param {AuthenticationService} authenticationService ユーザ認証サービス
	     */
	    /* @ngInject */
	    function HeaderController($window, $uibModal, $translate, pjInjectProxy, authenticationService) {
	        var _this = this;
	        _super.call(this, null, $translate, pjInjectProxy);
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.authenticationService = authenticationService;
	        authenticationService.getUser().then(function (user) {
	            _this.userid = user.data.userId;
	            _this.username = user.data.userName;
	        });
	    }
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    HeaderController.prototype.restore = function (data) {
	    };
	    /**
	     * 表示処理
	     */
	    HeaderController.prototype.show = function () {
	    };
	    /**
	     * ログアウトイベント
	     */
	    HeaderController.prototype.logout = function () {
	        this.$window.location.href = '../login/index.html#/';
	    };
	    /**
	     * ユーザ情報更新イベント
	     */
	    HeaderController.prototype.update = function () {
	        var _this = this;
	        this.$uibModal.open({
	            templateUrl: '../common/extends_fw/template/notice.html',
	            controller: 'NoticeDlgController',
	            controllerAs: 'Notice',
	            resolve: {
	                items: function ($q) {
	                    return $q.all([
	                        _this.$translate('ICS001001T', null, null, null, 'ja'),
	                        _this.$translate('ICS001001', null, null, null, 'ja')
	                    ]);
	                }
	            }
	        }).result.then(function (result) {
	        }).catch(function () {
	        });
	    };
	    return HeaderController;
	}(PjBaseController_1.PjBaseController));
	exports.HeaderController = HeaderController;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var framework = __webpack_require__(7);
	/**
	 * プロジェクト向け基盤Controller
	 */
	var PjBaseController = (function (_super) {
	    __extends(PjBaseController, _super);
	    /**
	     * コンストラクタ
	     * パラメータでプロパティの定義を実施
	     * @param {angular.ui.IStateParamsService} $stateParams UI Routerのパラメータ
	     * @param {ng.translate.ITranslateService} $translate angular-translateのサービス
	     * @param {PjInjectProxy} pjInjectProxy フレームワークで使用するサービス
	     */
	    function PjBaseController($stateParams, $translate, $location, pjInjectProxy) {
	        _super.call(this, $stateParams, $translate, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$translate = $translate;
	        this.$location = $location;
	        this.pjInjectProxyImpl = pjInjectProxy;
	        this.alerts = [];
	        this.pjInjectProxyImpl.getRootScope()['$validationOptions'] = { debounce: 1500 };
	    }
	    /**
	     * Menuの表示非表示を設定する
	     * @param {string} show 表示設定
	     */
	    PjBaseController.prototype.setMenu = function (show) {
	        this.pjInjectProxyImpl.getRootScope()['hideMenu'] = !show;
	    };
	    /**
	     * エラーハンドリング処理
	     * @param {number} status - HTTPステータスコード
	     * @param {pjfw.PjErrorInfo} errorInfo - エラー情報
	     * @return ハンドリングの内容 true:エラーハンドリングを実施 false: 業務例外のハンドリングを行う
	     */
	    PjBaseController.prototype.handleSystemError = function (status, errorInfo) {
	        // TODO システムで設計したエラーハンドリング処理を実装
	        // 下記はサンプルコード
	        switch (status) {
	            case 404:
	                this.pjInjectProxyImpl.getState().go('ERROR', { code: '404' });
	                return true;
	            case 500:
	                this.pjInjectProxyImpl.getState().go('ERROR', { code: errorInfo.params[0] });
	                return true;
	            default:
	                return false;
	        }
	    };
	    /**
	     * 履歴へ記録する処理
	     * @param {string} timestamp タイムスタンプ
	     * @param {any} data 記録するデータ
	     */
	    PjBaseController.prototype.addHistory = function (timestamp, data) {
	        this.pjInjectProxyImpl.getHistoryService().addHistory(timestamp, data);
	    };
	    /** 履歴を取得する処理
	     * @param {string} timestamp タイムスタンプ
	     * @return {ng.IPromise} 履歴から取得したデータ
	     */
	    PjBaseController.prototype.getHistory = function (timestamp) {
	        var deferred = this.pjInjectProxyImpl.getQ().defer();
	        // タイムスタンプから履歴の有無を検索し、履歴があれば返す。無ければ、nullを返す
	        if (this.pjInjectProxyImpl.getHistoryService().contains(timestamp)) {
	            this.pjInjectProxyImpl.getHistoryService().getHistory(timestamp).then(function (response) {
	                deferred.resolve(response.data);
	            });
	        }
	        else {
	            deferred.resolve(null);
	        }
	        return deferred.promise;
	    };
	    PjBaseController.prototype.setAlert = function (messageId) {
	        if (!messageId) {
	            return;
	        }
	        var type;
	        if (messageId.startsWith('error.')) {
	            type = 'error';
	        }
	        else {
	            type = 'info';
	        }
	        this.alerts.push({ type: type, message: this.$translate.instant(messageId) });
	    };
	    PjBaseController.prototype.setError = function (messageId) {
	        if (!messageId) {
	            return;
	        }
	        this.alerts.push({ type: 'error', message: this.$translate.instant(messageId) });
	    };
	    PjBaseController.prototype.clearAlert = function () {
	        this.alerts.splice(0, this.alerts.length);
	    };
	    PjBaseController.prototype.catch = function (errorData) {
	        this.clearAlert();
	        if (errorData.status === 400) {
	            if (errorData.data && errorData.data.messages) {
	                for (var i = 0; i < errorData.data.messages.length; i++) {
	                    this.setError(errorData.data.messages[i]);
	                }
	            }
	            else {
	                this.setAlert('error.0007');
	            }
	        }
	        if (errorData.status === 401) {
	            this.$location.url('/');
	            this.setAlert('error.0008');
	        }
	        if (errorData.status === 404) {
	            this.setAlert('error.0008');
	        }
	        if (errorData.status === 409) {
	            this.setAlert('error.0013');
	        }
	        if (errorData.status === 500) {
	            this.setAlert('message.0005');
	        }
	    };
	    PjBaseController.prototype.isTohmatsu = function () {
	        var auth = this.pjInjectProxyImpl.getSharedService().get('auth');
	        if (!auth) {
	            return false;
	        }
	        return (auth.role === 3 || auth.role === 4);
	    };
	    PjBaseController.prototype.isReadonly = function () {
	        var auth = this.pjInjectProxyImpl.getSharedService().get('auth');
	        if (!auth) {
	            return true;
	        }
	        return (auth.role === 4);
	    };
	    PjBaseController.prototype.checkAuthenticatedUser = function () {
	        var auth = this.pjInjectProxyImpl.getSharedService().get('auth');
	        if (!auth) {
	            this.$location.url('/');
	            return false;
	        }
	        return true;
	    };
	    return PjBaseController;
	}(framework.BaseController));
	exports.PjBaseController = PjBaseController;
	var SharedService = (function () {
	    function SharedService() {
	    }
	    SharedService.prototype.get = function (key) {
	        return JSON.parse(window.sessionStorage.getItem(key));
	    };
	    SharedService.prototype.set = function (key, value) {
	        return window.sessionStorage.setItem(key, JSON.stringify(value));
	    };
	    return SharedService;
	}());
	exports.SharedService = SharedService;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * システムエラー画面を表示する。
	 */
	var SystemErrorController = (function (_super) {
	    __extends(SystemErrorController, _super);
	    /**
	     * コンストラクタ
	     * @param {angular.ui.IStateParamsService} $stateParams 画面間の引き継ぎデータ
	     * @param {ng.translate.ITranslateService} $translate angular-translateのサービス
	     * @param {PjInjectProxy} pjInjectProxy インジェクタプロキシ
	     */
	    /* @ngInject */
	    function SystemErrorController($stateParams, $translate, pjInjectProxy) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.setTitle('システムエラー');
	        // エラーコードとメッセージを設定
	        this.code = $stateParams['code'];
	        this.$translate(this.code, null, null, null, 'ja').then(function (message) {
	            _this.msg = message;
	        });
	    }
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    SystemErrorController.prototype.restore = function (data) {
	    };
	    /**
	     * 表示処理
	     */
	    SystemErrorController.prototype.show = function () {
	    };
	    return SystemErrorController;
	}(PjBaseController_1.PjBaseController));
	exports.SystemErrorController = SystemErrorController;


/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * 確認ダイアログController
	 */
	var ConfirmDlgController = (function () {
	    /**
	     * コンストラクタ
	     * パラメータでプロパティの定義を実施
	     * @param {ng.ui.bootstrap.IModalServiceInstance} $uibModalInstance UI Bootstrapのモーダル部品
	     * @param {[string, string]} items ダイアログに表示するタイトルとメッセージ
	     */
	    /* @ngInject */
	    function ConfirmDlgController($uibModalInstance, items) {
	        this.title = items[0];
	        this.msg = items[1];
	    }
	    return ConfirmDlgController;
	}());
	exports.ConfirmDlgController = ConfirmDlgController;


/***/ },
/* 25 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * 通知ダイアログController
	 */
	var NoticeDlgController = (function () {
	    /**
	     * コンストラクタ
	     * パラメータでプロパティの定義を実施
	     * @param {ng.ui.bootstrap.IModalServiceInstance} $uibModalInstance UI Bootstrapのモーダル部品
	     * @param {[string, string]} items ダイアログに表示するタイトルとメッセージ
	     */
	    /* @ngInject */
	    function NoticeDlgController($uibModalInstance, items) {
	        this.title = items[0];
	        this.msg = items[1];
	    }
	    return NoticeDlgController;
	}());
	exports.NoticeDlgController = NoticeDlgController;


/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * プロジェクトの定数
	 */
	var CommonConst;
	(function (CommonConst) {
	    /**
	     * サーバのパス
	     */
	    CommonConst.SERVER_PATH = '/back';
	})(CommonConst = exports.CommonConst || (exports.CommonConst = {}));


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var BaseInjectProxyImpl_1 = __webpack_require__(28);
	/**
	 * フレームワークで使用するサービスを集約する
	 */
	var PjInjectProxyImpl = (function (_super) {
	    __extends(PjInjectProxyImpl, _super);
	    /**
	     * @constructor
	     * @param {ng.IRootScopeService} $rootScope ルートスコープ
	     * @param {ng.IQService} $q 非同期処理
	     * @param {angular.ui.IStateService} $state UI Routerのステータス
	     * @param {HistoryService} historyService 履歴管理サービス
	     */
	    /* @ngInject */
	    function PjInjectProxyImpl($rootScope, $q, $state, 
	        //  protected historyService: HistoryService,
	        sharedService) {
	        _super.call(this, $rootScope, $q, $state);
	        this.$rootScope = $rootScope;
	        this.$q = $q;
	        this.$state = $state;
	        this.sharedService = sharedService;
	        //        sharedService.set('auth', {role: 3, userId: 'test_user_id', companyId: 100, userName: 'ユーザネーム', companyName: 'テスト会社名'});
	    }
	    /**
	     * モーダルを取得
	     * @return {HistoryService} 履歴管理サービス
	     */
	    PjInjectProxyImpl.prototype.getHistoryService = function () {
	        return null;
	    };
	    /**
	     * SharedServiceを取得
	     * @return {sharedService} 履歴管理サービス
	     */
	    PjInjectProxyImpl.prototype.getSharedService = function () {
	        return this.sharedService;
	    };
	    return PjInjectProxyImpl;
	}(BaseInjectProxyImpl_1.BaseInjectProxyImpl));
	exports.PjInjectProxyImpl = PjInjectProxyImpl;


/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * フレームワークで使用するサービスを集約する
	 */
	var BaseInjectProxyImpl = (function () {
	    /**
	     * @constructor
	     * @param {ng.IRootScopeService} $rootScope ルートスコープ
	     * @param {ng.IQService} $q 非同期処理
	     * @param {ng.IQService} $state UI Routerのステータス
	     */
	    function BaseInjectProxyImpl($rootScope, $q, $state) {
	        this.$rootScope = $rootScope;
	        this.$q = $q;
	        this.$state = $state;
	    }
	    /**
	     * UI Routerのstateを取得
	     * @return {angular.ui.IStateService} UI Routerのstate
	     */
	    BaseInjectProxyImpl.prototype.getState = function () {
	        return this.$state;
	    };
	    /**
	     * rootScopeを取得
	     * @return {ng.IRootScopeService} rootScope
	     */
	    BaseInjectProxyImpl.prototype.getRootScope = function () {
	        return this.$rootScope;
	    };
	    /**
	     * $qを取得
	     * @return {ng.IQService} $q
	     */
	    BaseInjectProxyImpl.prototype.getQ = function () {
	        return this.$q;
	    };
	    return BaseInjectProxyImpl;
	}());
	exports.BaseInjectProxyImpl = BaseInjectProxyImpl;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var framework = __webpack_require__(7);
	var common = __webpack_require__(30);
	/**
	 * 共通的な設定を行う
	 * @param {ng.IModule} angularModule AngularJSのモジュール
	 */
	/* @ngInject */
	function config($provide, $httpProvider, $urlRouterProvider, $stateProvider, $translateProvider) {
	    // FWの共通設定を呼び出し
	    framework.config($httpProvider);
	    // $httpサービスに中断(インタセプター）処理を登録する。
	    $httpProvider.interceptors.push(framework.interceptor);
	    $httpProvider.interceptors.push(common.interceptor);
	    // 多国語化の業務設定
	    $translateProvider.fallbackLanguage(['ja', 'en', 'zh', 'id']);
	    $translateProvider.useStaticFilesLoader({
	        prefix: '../assets/i18n/locale-',
	        suffix: '.json'
	    });
	    // 選択したロケール名をStorageLocalに格納する。
	    $translateProvider.useLocalStorage();
	    $translateProvider.useSanitizeValueStrategy('escapeParameters');
	}
	exports.config = config;


/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	/**
	 * ロケールの送信処理部品
	 * @param {ng.IQService} $q
	 * @param {ng.auto.IInjectorService} $injector
	 */
	/* @ngInject */
	function interceptor($q, $injector) {
	    return {
	        request: function (config) {
	            var $translate = $injector.get('$translate');
	            if ($translate && $translate.use()) {
	                config.headers['X-HAF-DS-locale'] = $translate.use();
	            }
	            return config || $q.when(config);
	        }
	    };
	}
	exports.interceptor = interceptor;
	;


/***/ },
/* 31 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	/**
	 * Angularアプリケーションの構成情報作成
	 * 以下の構成情報についてプロバイダー(※）を使用して作成します。
	 * 構成情報：(1)URLルーティング設定
	 *           (2)$httpサービスにインタセプター設定
	 * ※プロバイダーとは、サービスの挙動を変更するためのコンポーネントです。
	 * @param $provide モジュールに対してコンポーネントを登録するためのサービス
	 * @param $httpProvider $httpサービスにおけるデフォルトの挙動を設定するプロバイダー
	 * @param $urlRouterProvider (UI Router)よるルーティングプロバイダー
	 * @param $stateProvider（UI Router)よるルーティングプロバイダー
	 */
	/* @ngInject */
	function config($provide, $httpProvider, $urlRouterProvider, $stateProvider) {
	    $stateProvider
	        .state('top', {
	        url: '/top',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/dashboard/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'dashboardController',
	                controllerAs: 'dashboard' } }
	    }).state('login', {
	        url: '/',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/login/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'loginController',
	                controllerAs: 'login' } }
	    }).state('loginPassword', {
	        url: '/loginPassword',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/loginPassword/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'loginPasswordController',
	                controllerAs: 'loginPassword' } }
	    }).state('user', {
	        url: '/user',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/user/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'userController',
	                controllerAs: 'user' } }
	    }).state('viewingHistory', {
	        url: '/history/:page/:name',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/viewingHistory/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'viewingHistoryController',
	                controllerAs: 'viewingHistory' } }
	    }).state('company', {
	        url: '/company',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/company/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'companyController',
	                controllerAs: 'company' } }
	    }).state('group', {
	        url: '/group',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/group/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'groupController',
	                controllerAs: 'group' } }
	    }).state('video', {
	        url: '/video',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/video/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'videoController',
	                controllerAs: 'video' } }
	    }).state('category', {
	        url: '/category',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/category/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'categoryController',
	                controllerAs: 'category' } }
	    }).state('recommend', {
	        url: '/recommend',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/recommend/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'recommendController',
	                controllerAs: 'recommend' } }
	    }).state('series', {
	        url: '/series',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/series/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'seriesController',
	                controllerAs: 'series' } }
	    }).state('pack', {
	        url: '/pack',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/pack/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'packController',
	                controllerAs: 'pack' } }
	    }).state('notice', {
	        url: '/notice',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/notice/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'noticeController',
	                controllerAs: 'notice' } }
	    }).state('userCap', {
	        url: '/userCap',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/userCap/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'userCapController',
	                controllerAs: 'userCap' } }
	    }).state('password', {
	        url: '/password',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/password/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'passwordController',
	                controllerAs: 'password' } }
	    }).state('blank', {
	        url: '/blank/:go',
	        views: { 'main': { templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('template/blank/index.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'blankController',
	                controllerAs: 'blank' } }
	    }).state('ERROR', {
	        url: '/error',
	        params: {
	            code: null,
	            msg: null // エラーメッセージ
	        },
	        views: {
	            'main': {
	                templateProvider: function ($translate, $templateFactory, $templateCache) {
	                    return getNextTemplate('../common/error/template/SystemError.html', $templateFactory, $templateCache, $translate);
	                },
	                controller: 'SystemErrorController',
	                controllerAs: 'error'
	            }
	        }
	    });
	}
	exports.config = config;
	/**
	 * テンプレートの取得処理（テンプレートキャッシュの利用が前提）
	 * 指定されたロケールのテンプレートを取得する。
	 * 指定したロケールのテンプレートが存在しない場合は、プレフィックスなしのテンプレート→fallbackLanguageのテンプレートの順に取得する。
	 * @param {string} templateUrl テンプレートのURL(プレフィックスなし)
	 * @param {any} $templateFactory UI Routerのテンプレート管理サービス
	 * @param {ng.ITemplateCacheService} $templateCache AngularJSのテンプレートキャッシュの管理サービス
	 * @param {ng.translate.ITranslateService} $translate Angular Translaeのサービス
	 * @param {authenticationCheckService} AuthenticationCheckService 認証チェック部品
	 * @return {string} 表示するテンプレート
	 */
	function getNextTemplate(templateUrl, $templateFactory, $templateCache, $translate, authenticationCheckService) {
	    var str = templateUrl.split('.');
	    var translate = str[0] + '_' + $translate.use() + '.' + str[1];
	    var url = null;
	    // 指定ロケールのテンプレートの有無のチェック
	    if ($templateCache.get(translate)) {
	        // 指定ロケールのプレフィックスのファイルを使用
	        url = translate;
	    }
	    else {
	        // プレフィックスなしのテンプレートの有無チェック
	        if ($templateCache.get(templateUrl)) {
	            // プレフィックスなしのテンプレートを使用
	            url = templateUrl;
	        }
	        else {
	            // fallbackLanguageのロケールをプレフィックスとするテンプレートを使用
	            var locals = $translate.fallbackLanguage();
	            if (Array.isArray(locals)) {
	                // 配列の場合
	                for (var i = 0; i < locals.length; i++) {
	                    var fallback = str[0] + '_' + locals[i] + '.' + str[1];
	                    if ($templateCache.get(fallback)) {
	                        url = fallback;
	                        break;
	                    }
	                }
	            }
	            else {
	                // 文字列の場合
	                var fallback = str[0] + '_' + locals + '.' + str[1];
	                if ($templateCache.get(fallback)) {
	                    url = fallback;
	                }
	            }
	        }
	    }
	    if (url) {
	        // 適切なテンプレートがある場合
	        if (authenticationCheckService) {
	            return authenticationCheckService.isAuthenticated(url);
	        }
	        else {
	            return $templateFactory.fromUrl(url);
	        }
	    }
	    else {
	        // テンプレートが無い場合（アプリケーションの不具合のため、開発者への通知用）
	        // テンプレートキャッシュを前提としているため、通信状況によりテンプレートが取得できないという問題はない
	        console.error(templateUrl + 'のテンプレートが存在しません');
	        alert(templateUrl + 'のテンプレートが存在しません');
	    }
	}


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var PjBaseController_1 = __webpack_require__(22);
	var Net_1 = __webpack_require__(33);
	var CommonConst_1 = __webpack_require__(26);
	var DashboardController_1 = __webpack_require__(34);
	var DashboardService_1 = __webpack_require__(35);
	var DashboardApi_1 = __webpack_require__(36);
	var HeaderController_1 = __webpack_require__(37);
	var HeaderService_1 = __webpack_require__(38);
	var HeaderApi_1 = __webpack_require__(39);
	var LoginController_1 = __webpack_require__(40);
	var LoginService_1 = __webpack_require__(41);
	var LoginApi_1 = __webpack_require__(42);
	var LoginPasswordController_1 = __webpack_require__(43);
	var LoginPasswordService_1 = __webpack_require__(44);
	var LoginPasswordApi_1 = __webpack_require__(45);
	var UserController_1 = __webpack_require__(46);
	var UserService_1 = __webpack_require__(47);
	var UserApi_1 = __webpack_require__(48);
	var ViewingHistoryController_1 = __webpack_require__(49);
	var ViewingHistoryService_1 = __webpack_require__(50);
	var ViewingHistoryApi_1 = __webpack_require__(51);
	var CompanyController_1 = __webpack_require__(52);
	var CompanyService_1 = __webpack_require__(53);
	var CompanyApi_1 = __webpack_require__(54);
	var GroupController_1 = __webpack_require__(55);
	var GroupService_1 = __webpack_require__(56);
	var GroupApi_1 = __webpack_require__(57);
	var VideoController_1 = __webpack_require__(58);
	var VideoService_1 = __webpack_require__(59);
	var VideoApi_1 = __webpack_require__(60);
	var CategoryController_1 = __webpack_require__(61);
	var CategoryService_1 = __webpack_require__(62);
	var CategoryApi_1 = __webpack_require__(63);
	var RecommendController_1 = __webpack_require__(64);
	var RecommendService_1 = __webpack_require__(65);
	var RecommendApi_1 = __webpack_require__(66);
	var SeriesController_1 = __webpack_require__(67);
	var SeriesService_1 = __webpack_require__(68);
	var SeriesApi_1 = __webpack_require__(69);
	var PackController_1 = __webpack_require__(70);
	var PackService_1 = __webpack_require__(71);
	var PackApi_1 = __webpack_require__(72);
	var NoticeController_1 = __webpack_require__(73);
	var NoticeService_1 = __webpack_require__(74);
	var NoticeApi_1 = __webpack_require__(75);
	var UserCapController_1 = __webpack_require__(76);
	var UserCapService_1 = __webpack_require__(77);
	var UserCapApi_1 = __webpack_require__(78);
	var PasswordController_1 = __webpack_require__(79);
	var PasswordService_1 = __webpack_require__(80);
	var PasswordApi_1 = __webpack_require__(81);
	var BlankController_1 = __webpack_require__(82);
	/**
	 * AngularJSのモジュールに大分類で作成するべきコンポーネントを登録します
	 * @param {ng.IModule} angularModule AngularJSのモジュール
	 */
	function init(angularModule) {
	    angularModule.factory('sharedService', function () {
	        return new PjBaseController_1.SharedService();
	    });
	    angularModule.controller('dashboardController', DashboardController_1.DashboardController);
	    angularModule.service('dashboardService', DashboardService_1.DashboardService);
	    angularModule.factory('dashboardApi', function ($http, $q, $httpParamSerializer) {
	        return new DashboardApi_1.DashboardApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('headerMAController', HeaderController_1.HeaderController);
	    angularModule.service('headerService', HeaderService_1.HeaderService);
	    angularModule.factory('headerApi', function ($http, $q, $httpParamSerializer) {
	        return new HeaderApi_1.HeaderApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('loginController', LoginController_1.LoginController);
	    angularModule.controller('loginEditController', LoginController_1.LoginEditController);
	    angularModule.service('loginService', LoginService_1.LoginService);
	    angularModule.factory('loginApi', function ($http, $q, $httpParamSerializer) {
	        return new LoginApi_1.LoginApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('loginPasswordController', LoginPasswordController_1.LoginPasswordController);
	    angularModule.service('loginPasswordService', LoginPasswordService_1.LoginPasswordService);
	    angularModule.factory('loginPasswordApi', function ($http, $q, $httpParamSerializer) {
	        return new LoginPasswordApi_1.LoginPasswordApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('userController', UserController_1.UserController);
	    angularModule.controller('userEditController', UserController_1.UserEditController);
	    angularModule.service('userService', UserService_1.UserService);
	    angularModule.factory('userApi', function ($http, $q, $httpParamSerializer) {
	        return new UserApi_1.UserApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('viewingHistoryController', ViewingHistoryController_1.ViewingHistoryController);
	    angularModule.service('viewingHistoryService', ViewingHistoryService_1.ViewingHistoryService);
	    angularModule.factory('viewingHistoryApi', function ($http, $q, $httpParamSerializer) {
	        return new ViewingHistoryApi_1.ViewingHistoryApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('companyController', CompanyController_1.CompanyController);
	    angularModule.controller('companyEditController', CompanyController_1.CompanyEditController);
	    angularModule.service('companyService', CompanyService_1.CompanyService);
	    angularModule.factory('companyApi', function ($http, $q, $httpParamSerializer) {
	        return new CompanyApi_1.CompanyApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('groupController', GroupController_1.GroupController);
	    angularModule.controller('groupEditController', GroupController_1.GroupEditController);
	    angularModule.service('groupService', GroupService_1.GroupService);
	    angularModule.factory('groupApi', function ($http, $q, $httpParamSerializer) {
	        return new GroupApi_1.GroupApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('videoController', VideoController_1.VideoController);
	    angularModule.controller('videoEditController', VideoController_1.VideoEditController);
	    angularModule.service('videoService', VideoService_1.VideoService);
	    angularModule.factory('videoApi', function ($http, $q, Upload, $httpParamSerializer) {
	        return new VideoApi_1.VideoApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH), Upload);
	    });
	    angularModule.controller('categoryController', CategoryController_1.CategoryController);
	    angularModule.controller('categoryEditController', CategoryController_1.CategoryEditController);
	    angularModule.service('categoryService', CategoryService_1.CategoryService);
	    angularModule.factory('categoryApi', function ($http, $q, $httpParamSerializer) {
	        return new CategoryApi_1.CategoryApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('recommendController', RecommendController_1.RecommendController);
	    angularModule.controller('recommendEditController', RecommendController_1.RecommendEditController);
	    angularModule.service('recommendService', RecommendService_1.RecommendService);
	    angularModule.factory('recommendApi', function ($http, $q, $httpParamSerializer) {
	        return new RecommendApi_1.RecommendApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('seriesController', SeriesController_1.SeriesController);
	    angularModule.controller('seriesEditController', SeriesController_1.SeriesEditController);
	    angularModule.service('seriesService', SeriesService_1.SeriesService);
	    angularModule.factory('seriesApi', function ($http, $q, $httpParamSerializer) {
	        return new SeriesApi_1.SeriesApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('packController', PackController_1.PackController);
	    angularModule.controller('packEditController', PackController_1.PackEditController);
	    angularModule.service('packService', PackService_1.PackService);
	    angularModule.factory('packApi', function ($http, $q, $httpParamSerializer) {
	        return new PackApi_1.PackApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('noticeController', NoticeController_1.NoticeController);
	    angularModule.controller('noticeEditController', NoticeController_1.NoticeEditController);
	    angularModule.service('noticeService', NoticeService_1.NoticeService);
	    angularModule.factory('noticeApi', function ($http, $q, $httpParamSerializer) {
	        return new NoticeApi_1.NoticeApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('userCapController', UserCapController_1.UserCapController);
	    angularModule.service('userCapService', UserCapService_1.UserCapService);
	    angularModule.factory('userCapApi', function ($http, $q, Upload, $httpParamSerializer) {
	        return new UserCapApi_1.UserCapApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH), Upload);
	    });
	    angularModule.controller('passwordController', PasswordController_1.PasswordController);
	    angularModule.service('passwordService', PasswordService_1.PasswordService);
	    angularModule.factory('passwordApi', function ($http, $q, $httpParamSerializer) {
	        return new PasswordApi_1.PasswordApi($http, $q, $httpParamSerializer, CommonConst_1.CommonConst.SERVER_PATH, new Net_1.Net($http, CommonConst_1.CommonConst.SERVER_PATH));
	    });
	    angularModule.controller('blankController', BlankController_1.BlankController);
	    angularModule.config(function ($sceDelegateProvider) {
	        $sceDelegateProvider.resourceUrlWhitelist([
	            // Allow same origin resource loads.
	            'self',
	            // Allow loading from our assets domain. **.
	            'http://d3se3bdfhhn1od.cloudfront.net/**',
	            'https://d3se3bdfhhn1od.cloudfront.net/**',
	            'http://dkn07u612dhp2.cloudfront.net/**',
	            'https://dkn07u612dhp2.cloudfront.net/**',
	            'http://d8sfhlnam129q.cloudfront.net/**',
	            'https://d8sfhlnam129q.cloudfront.net/**'
	        ]);
	    });
	    angularModule.config(function ($provide) {
	        var directiveTypes = ['Submit', 'Click'];
	        angular.forEach(directiveTypes, function (type, key) {
	            $provide.decorator(('ng' + type + 'Directive'), function ($delegate, $parse) {
	                $delegate[0].compile = function ($element, attr) {
	                    var fn = $parse(attr['ng' + type], null, true);
	                    var timer;
	                    return function (scope, element) {
	                        element.on(type.toLowerCase(), function (event) {
	                            var _fn = function () {
	                                scope.$apply(function () {
	                                    fn(scope, { '$event': event });
	                                });
	                            };
	                            if (timer) {
	                                clearTimeout(timer);
	                            }
	                            timer = setTimeout(_fn, 100); // 処理中のボタン操作不可時間
	                        });
	                        var destroyer = scope.$on('$destroy', function () {
	                            element.off();
	                            destroyer();
	                        });
	                    };
	                };
	                return $delegate;
	            });
	        });
	    });
	}
	exports.init = init;


/***/ },
/* 33 */
/***/ function(module, exports) {

	"use strict";
	var Net = (function () {
	    function Net($http, basePath) {
	        this.$http = $http;
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    Net.prototype.http = function (url, param, method) {
	        var path = this.basePath + url;
	        var httpRequestParams = {
	            method: method, url: path, unique: true, screenId: path };
	        var newParam = this.createParam(param);
	        if (method === 'GET') {
	            httpRequestParams.params = newParam;
	        }
	        else {
	            httpRequestParams.data = newParam;
	        }
	        return this.$http(httpRequestParams);
	    };
	    Net.prototype.get = function (url, param) {
	        return this.http(url, param, 'GET');
	    };
	    Net.prototype.post = function (url, param) {
	        return this.http(url, param, 'POST');
	    };
	    Net.prototype.createParam = function (param) {
	        var _this = this;
	        var newParam = {};
	        if (param) {
	            Object.keys(param).forEach(function (key) {
	                if (param[key] instanceof Date) {
	                    newParam[key] = _this.formatDate(param[key]);
	                }
	                else {
	                    newParam[key] = param[key];
	                }
	            });
	        }
	        else {
	            newParam = param;
	        }
	        return newParam;
	    };
	    Net.prototype.formatDate = function (date) {
	        var month = '' + (date.getMonth() + 1);
	        var day = '' + date.getDate();
	        var year = '' + date.getFullYear();
	        if (month.length < 2) {
	            month = '0' + month;
	        }
	        if (day.length < 2) {
	            day = '0' + day;
	        }
	        return [year, month, day].join('-');
	    };
	    return Net;
	}());
	exports.Net = Net;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * ログイン画面について出力処理およびイベント処理を行う。
	 */
	var DashboardController = (function (_super) {
	    __extends(DashboardController, _super);
	    /**
	     * コンストラクタ
	     * @param {angular.ui.IStateParamsService} $stateParams 画面間の引き継ぎデータ
	     * @param {ng.IWindowService} $window Windowオブジェクト
	     * @param {ng.ui.bootstrap.IModalService} $uibModal モーダル
	     * @param {ng.translate.ITranslateService} $translate 多国語化部品サービス
	     * @param {PjInjectProxy} pjInjectProxy インジェクタプロキシ
	     * @param {AuthenticationService} authenticationService 認証サービス
	     */
	    /* @ngInject */
	    function DashboardController($stateParams, $window, $uibModal, $translate, pjInjectProxy, authenticationService, dashboardService, $location, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.authenticationService = authenticationService;
	        this.dashboardService = dashboardService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        // アクセスラベル
	        this.accessLabel = [];
	        // アクセスカウント
	        this.accessCount = [];
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form34.title');
	        this.setMenu(true);
	        this.draw();
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'title',
	                    displayName: '件名',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.title}}</a>' + '<div>'
	                },
	                {
	                    field: 'date',
	                    displayName: '公開開始日',
	                    width: '13%'
	                }
	            ],
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	        };
	        this.gridOptions2 = this.getOptions();
	        this.gridOptions3 = this.getOptions();
	        this.gridOptions4 = this.getOptions();
	        //  sharedService利用　role:利用者の強制ログアウト
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはログインへ戻す
	        if (auth) {
	            if (!(auth.role === 2 || auth.role === 3 || auth.role === 4)) {
	                this.$location.url('/');
	            }
	        }
	        this.getNotice();
	        this.getRanking('1', this.gridOptions2);
	        this.getRanking('2', this.gridOptions3);
	        this.getRanking('3', this.gridOptions4);
	        this.getAccess();
	        $scope.getColumnDefs = this.getColumnDefs;
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	    }
	    /**
	     * ダイアログ表示
	     */
	    DashboardController.prototype.show_dialog = function (id) {
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/notice/detail.html',
	            controller: 'noticeEditController',
	            controllerAs: 'noticeEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	            }
	        });
	    };
	    DashboardController.prototype.getNotice = function () {
	        var _this = this;
	        var criteria = {
	            dateFlg: 1
	        };
	        this.dashboardService.getNotice(criteria).then(function (data) {
	            if (data.status === 204) {
	                _this.$scope.viewNotice = false;
	            }
	            else {
	                if (_this.gridOptions.data === undefined || _this.gridOptions.data === null) {
	                    _this.gridOptions.data = data.data.notices;
	                }
	                else {
	                    _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	                    Array.prototype.push.apply(_this.gridOptions.data, data.data.notices);
	                }
	                _this.$scope.viewNotice = true;
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    DashboardController.prototype.getOptions = function () {
	        return {
	            columnDefs: [
	                {
	                    field: 'rank',
	                    displayName: '順位',
	                    cellTemplate: '<div class="ranking {{grid.appScope.getColumnDefs(row.entity.rank)}}">{{row.entity.rank}}</div>',
	                    width: '27%'
	                },
	                {
	                    field: 'title',
	                    displayName: '動画名',
	                }
	            ],
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	        };
	    };
	    DashboardController.prototype.getColumnDefs = function (rank) {
	        if (rank == 1) {
	            return 'rankImg';
	        }
	        else {
	            return '';
	        }
	    };
	    DashboardController.prototype.getRanking = function (id, gridOption) {
	        var _this = this;
	        this.dashboardService.getRanking(id).then(function (data) {
	            if (data.status === 204) {
	                if (id === '1') {
	                    _this.$scope.viewStart = false;
	                }
	                else if (id === '2') {
	                    _this.$scope.viewBookmark = false;
	                }
	                else {
	                    _this.$scope.viewEvaluation = false;
	                }
	            }
	            else {
	                if (gridOption.data === undefined || gridOption.data === null) {
	                    gridOption.data = data.data.rankings;
	                }
	                else {
	                    gridOption.data.splice(0, gridOption.data.length);
	                    Array.prototype.push.apply(gridOption.data, data.data.rankings);
	                }
	                if (id === '1') {
	                    _this.$scope.viewStart = true;
	                }
	                else if (id === '2') {
	                    _this.$scope.viewBookmark = true;
	                }
	                else {
	                    _this.$scope.viewEvaluation = true;
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    DashboardController.prototype.getAccess = function () {
	        var _this = this;
	        this.dashboardService.getAccess().then(function (data) {
	            if (data.status === 204) {
	                _this.$scope.viewAccess = false;
	            }
	            else {
	                var lineChartCanvas = $('#lineChart')[0].getContext('2d');
	                var strCount = void 0;
	                if (data.data.ranking) {
	                    strCount = data.data.ranking.count.split(',');
	                    var numCount = [];
	                    for (var i = 0; i < strCount.length; i++) {
	                        numCount.push(Number(strCount[i]));
	                    }
	                    _this.lineChartData = {
	                        labels: data.data.ranking.date,
	                        datasets: [
	                            {
	                                label: 'アクセス数',
	                                // fillColor: 'rgba(60,141,188,0.9)',
	                                borderColor: 'rgba(60,141,188,0.8)',
	                                fill: false,
	                                pointRadius: 0,
	                                pointHitRadius: 10,
	                                data: numCount,
	                            }
	                        ]
	                    };
	                    var lineChartOptions = {
	                        responsive: true,
	                        legend: {
	                            display: false
	                        },
	                        scales: {
	                            xAxes: [{
	                                    ticks: {
	                                        autoSkip: false,
	                                    },
	                                    gridLines: {
	                                        display: false,
	                                    },
	                                }],
	                            yAxes: [{
	                                    ticks: {
	                                        min: 0,
	                                        userCallback: function (label, index, labels) {
	                                            if (Math.floor(label) === label) {
	                                                return label;
	                                            }
	                                        },
	                                    },
	                                    gridLines: {
	                                        display: false,
	                                    },
	                                }]
	                        }
	                    };
	                    if (data.data.result == 0) {
	                        lineChartOptions.scales.yAxes[0].ticks.max = 1;
	                    }
	                    var lineChart = new Chart.Line(lineChartCanvas, {
	                        data: _this.lineChartData,
	                        options: lineChartOptions
	                    });
	                    _this.$scope.viewAccess = true;
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    DashboardController.prototype.restore = function (data) {
	    };
	    /**
	     * 表示処理
	     */
	    DashboardController.prototype.show = function () {
	    };
	    return DashboardController;
	}(PjBaseController_1.PjBaseController));
	exports.DashboardController = DashboardController;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * パスワード情報を管理する。
	 */
	var DashboardService = (function (_super) {
	    __extends(DashboardService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function DashboardService($q, dashboardApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.dashboardApi = dashboardApi;
	    }
	    /**
	     * お知らせ取得
	     */
	    DashboardService.prototype.getNotice = function (criteria) {
	        return this.dashboardApi.getNotice(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * アクセス数取得
	     */
	    DashboardService.prototype.getAccess = function () {
	        return this.dashboardApi.getAccess().then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * ランキング取得
	     */
	    DashboardService.prototype.getRanking = function (id) {
	        return this.dashboardApi.getRanking(id).then(function (data) {
	            return data;
	        });
	    };
	    return DashboardService;
	}(PjBaseService_1.PjBaseService));
	exports.DashboardService = DashboardService;


/***/ },
/* 36 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var DashboardApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function DashboardApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * お知らせの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    DashboardApi.prototype.getNotice = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/notices/search', criteria);
	    };
	    /**
	     * アクセス数を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    DashboardApi.prototype.getAccess = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/rankings/accsesHistory', null);
	    };
	    /**
	     * お知らせの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    DashboardApi.prototype.getRanking = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        if (id === '1') {
	            return this.$net.get('/rankings/count', null);
	        }
	        else if (id === '2') {
	            return this.$net.get('/rankings/bookmark', null);
	        }
	        else if (id === '3') {
	            return this.$net.get('/rankings/evaluation', null);
	        }
	    };
	    return DashboardApi;
	}());
	exports.DashboardApi = DashboardApi;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * 会社画面について出力処理およびイベント処理を行う。
	 */
	var HeaderController = (function (_super) {
	    __extends(HeaderController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function HeaderController($stateParams, $window, $uibModal, $translate, pjInjectProxy, headerService, $location, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.headerService = headerService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        //  項目の表示制御
	        $scope.tohmatsu = this.isTohmatsu();
	        $scope.companyMana = !this.isTohmatsu();
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        if (auth) {
	            this.userName = auth.userName || '';
	            this.companyName = auth.companyName || '';
	        }
	        pjInjectProxy.$rootScope.$on('change_authinfo', function (event, args) {
	            _this.go('/top');
	        });
	    }
	    /**
	     * ロケーション切替イベント
	     */
	    HeaderController.prototype.go = function (url) {
	        this.$location.url('/blank' + url);
	        //  項目の表示制御
	        this.$scope.tohmatsu = this.isTohmatsu();
	        this.$scope.companyMana = !this.isTohmatsu();
	        //  sharedService
	        var auth;
	        auth = this.sharedService.get('auth');
	        if (auth) {
	            this.userName = auth.userName || '';
	            this.companyName = auth.companyName || '';
	        }
	    };
	    ;
	    /**
	     * Logoutイベント
	     */
	    HeaderController.prototype.logout = function () {
	        var _this = this;
	        this.headerService.logout().then(function (data) {
	            // ユーザ切替時のlogoutはdataが返る
	            // 通常のlogoutはブランクのdataが返る
	            if (Object.keys(data.data).length !== 0) {
	                _this.userInfo = data.data.user;
	                _this.sharedService.set('auth', { role: parseInt(_this.userInfo.role), userId: _this.userInfo.userId, userName: _this.userInfo.userName, companyId: _this.userInfo.companyId, companyName: _this.userInfo.companyName });
	                _this.go('/top');
	            }
	            else {
	                _this.sharedService.set('auth', {});
	                _this.$location.url('/');
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    ;
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    HeaderController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    HeaderController.prototype.show = function () { };
	    return HeaderController;
	}(PjBaseController_1.PjBaseController));
	exports.HeaderController = HeaderController;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * パスワード情報を管理する。
	 */
	var HeaderService = (function (_super) {
	    __extends(HeaderService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function HeaderService($q, headerApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.headerApi = headerApi;
	    }
	    /**
	     * ログアウト
	     */
	    HeaderService.prototype.logout = function () {
	        return this.headerApi.logout().then(function (data) {
	            return data;
	        });
	    };
	    return HeaderService;
	}(PjBaseService_1.PjBaseService));
	exports.HeaderService = HeaderService;


/***/ },
/* 39 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var HeaderApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function HeaderApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * ログインユーザの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    HeaderApi.prototype.logout = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/users/logout', null);
	    };
	    return HeaderApi;
	}());
	exports.HeaderApi = HeaderApi;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * パスワード画面について出力処理およびイベント処理を行う。
	 */
	var LoginController = (function (_super) {
	    __extends(LoginController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function LoginController($stateParams, $window, $uibModal, $translate, pjInjectProxy, loginService, $location, sharedService, $scope, ValidationService) {
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.loginService = loginService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        this.ValidationService = ValidationService;
	        this.setTitle('form01.title');
	        this.setMenu(false);
	    }
	    LoginController.prototype.login = function () {
	        var _this = this;
	        if (!new this.ValidationService().checkFormValidity(this.$scope.loginIn)) {
	            return;
	        }
	        var record = {
	            userId: this.userId,
	            password: this.password
	        };
	        this.record = record;
	        this.loginService.login(this.record).then(function (data) {
	            _this.userInfo = data.data.user;
	            _this.sharedService.set('auth', { role: parseInt(_this.userInfo.role), userId: _this.userInfo.userId, userName: _this.userInfo.userName, companyId: _this.userInfo.companyId, companyName: _this.userInfo.companyName });
	            if (_this.userInfo.passwordChangeDate === null) {
	                _this.$location.url('/loginPassword');
	            }
	            else {
	                _this.$location.url('/top');
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * ダイアログ表示
	     */
	    LoginController.prototype.show_dialog = function (id) {
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/login/edit.html',
	            controller: 'loginEditController',
	            controllerAs: 'loginEdit'
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    LoginController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    LoginController.prototype.show = function () { };
	    return LoginController;
	}(PjBaseController_1.PjBaseController));
	exports.LoginController = LoginController;
	var LoginEditController = (function (_super) {
	    __extends(LoginEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function LoginEditController($stateParams, $uibModalInstance, $translate, $location, pjInjectProxy, loginService, $scope) {
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.$location = $location;
	        this.pjInjectProxy = pjInjectProxy;
	        this.loginService = loginService;
	        this.$scope = $scope;
	        this.modalTitle = 'form03.title';
	    }
	    LoginEditController.prototype.passwordInit = function () {
	        var _this = this;
	        var query = {
	            userId: this.userId
	        };
	        this.loginService.passwordInit(query).then(function (data) {
	            _this.$uibModalInstance.close('passwordInit');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    LoginEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    LoginEditController.prototype.show = function () { };
	    return LoginEditController;
	}(PjBaseController_1.PjBaseController));
	exports.LoginEditController = LoginEditController;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * パスワード情報を管理する。
	 */
	var LoginService = (function (_super) {
	    __extends(LoginService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function LoginService($q, loginApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.loginApi = loginApi;
	    }
	    /**
	     * ログイン
	     */
	    LoginService.prototype.login = function (record) {
	        return this.loginApi.login(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * パスワード問合せ
	     */
	    LoginService.prototype.passwordInit = function (email) {
	        return this.loginApi.passwordInit(email).then(function (data) {
	            return data;
	        });
	    };
	    return LoginService;
	}(PjBaseService_1.PjBaseService));
	exports.LoginService = LoginService;


/***/ },
/* 42 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var LoginApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function LoginApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * ログインユーザの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    LoginApi.prototype.login = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/users/admin', record);
	    };
	    /**
	     * メールアドレスを送信する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    LoginApi.prototype.passwordInit = function (email, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/users/send', email);
	    };
	    return LoginApi;
	}());
	exports.LoginApi = LoginApi;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * パスワード画面について出力処理およびイベント処理を行う。
	 */
	var LoginPasswordController = (function (_super) {
	    __extends(LoginPasswordController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function LoginPasswordController($stateParams, $window, $uibModal, $translate, pjInjectProxy, loginPasswordService, $location, $scope) {
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.loginPasswordService = loginPasswordService;
	        this.$location = $location;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        //  this.setTitle('form02.title');
	        this.setMenu(false);
	    }
	    LoginPasswordController.prototype.setPassword = function () {
	        var _this = this;
	        var pass = {
	            password: this.password
	        };
	        this.upPassword = pass;
	        this.loginPasswordService.setPassword(this.upPassword).then(function (data) {
	            _this.$location.url('/top');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    LoginPasswordController.prototype.passwordChanged = function () {
	        this.$scope.$broadcast('angularValidation.revalidate', 'passwordRe');
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    LoginPasswordController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    LoginPasswordController.prototype.show = function () { };
	    return LoginPasswordController;
	}(PjBaseController_1.PjBaseController));
	exports.LoginPasswordController = LoginPasswordController;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * パスワード情報を管理する。
	 */
	var LoginPasswordService = (function (_super) {
	    __extends(LoginPasswordService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function LoginPasswordService($q, loginPasswordApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.loginPasswordApi = loginPasswordApi;
	    }
	    /**
	     * パスワード更新
	     */
	    LoginPasswordService.prototype.setPassword = function (password) {
	        return this.loginPasswordApi.setPassword(password).then(function (data) {
	            return data;
	        });
	    };
	    return LoginPasswordService;
	}(PjBaseService_1.PjBaseService));
	exports.LoginPasswordService = LoginPasswordService;


/***/ },
/* 45 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var LoginPasswordApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function LoginPasswordApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * パスワードの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    LoginPasswordApi.prototype.setPassword = function (password, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/users/updateLoginPassword', password);
	    };
	    return LoginPasswordApi;
	}());
	exports.LoginPasswordApi = LoginPasswordApi;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * ユーザ画面について出力処理およびイベント処理を行う。
	 */
	var UserController = (function (_super) {
	    __extends(UserController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function UserController($stateParams, $window, $uibModal, $translate, pjInjectProxy, userService, $location, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.userService = userService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form04.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'companyName',
	                    displayName: 'item.0016',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'userName',
	                    displayName: 'item.0092',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.userName}}</a>' + '<div>',
	                    width: '28%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'role',
	                    displayName: 'item.0036',
	                    width: '24%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'startDate',
	                    displayName: 'item.0094',
	                    width: '13%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'disable',
	                    displayName: 'item.0096',
	                    width: '12%',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (!(auth.role === 2 || auth.role === 3 || auth.role === 4)) {
	            this.$location.url('/top');
	        }
	        //  項目の表示制御
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    /**
	     * ダイアログ表示
	     */
	    UserController.prototype.show_dialog = function (id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/user/edit.html',
	            controller: 'userEditController',
	            controllerAs: 'userEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	                _this.clearAlert();
	                if (result === 'delete') {
	                    _this.setAlert('message.0027');
	                }
	                _this.reflesh_list(result);
	            }
	        });
	    };
	    UserController.prototype.reflesh_list = function (result) {
	        var _this = this;
	        this.userService.list(this.criteria).then(function (data) {
	            _this.$scope.gridApi.selection.clearSelectedRows();
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.users);
	            if (result !== 'delete') {
	                _this.clearAlert();
	                if (data.status === 204) {
	                    _this.setAlert('message.0004');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    UserController.prototype.search = function () {
	        var criteria = {
	            companyName: this.companyName,
	            userName: this.userName,
	            role: this.role,
	            startDate: this.startDate,
	            disable: Number(this.disable) || null
	        };
	        this.criteria = criteria;
	        this.reflesh_list('search');
	    };
	    UserController.prototype.delete = function () {
	        var _this = this;
	        var rows = this.$scope.gridApi.selection.getSelectedRows();
	        if (rows.length === 0) {
	            alert(this.$translate.instant('MC0000001'));
	            return;
	        }
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.userService.delete(rows.map(function (x) { return x.id; })).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0027');
	            _this.reflesh_list('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    // ユーザ取込ボタン押下時遷移
	    UserController.prototype.cap = function () {
	        this.$location.url('/userCap');
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    UserController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    UserController.prototype.show = function () { };
	    return UserController;
	}(PjBaseController_1.PjBaseController));
	exports.UserController = UserController;
	var UserEditController = (function (_super) {
	    __extends(UserEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function UserEditController($stateParams, $uibModalInstance, $translate, pjInjectProxy, userService, $scope, sharedService, $location, id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.userService = userService;
	        this.$scope = $scope;
	        this.sharedService = sharedService;
	        this.$location = $location;
	        this.id = id;
	        this.changeItem = function () {
	            var roleId = this.record.role;
	            if (roleId === '2') {
	                this.$scope.companyRole = false;
	                this.$scope.user.$setUntouched();
	            }
	            else {
	                this.record.companyId = null;
	                this.$scope.companyRole = true;
	            }
	        };
	        if (id) {
	            this.modalTitle = 'form06.title';
	            this.submitCaption = 'RC0000004';
	            this.getRecord(id);
	        }
	        else {
	            this.record = {};
	            this.record.startDate = new Date();
	            this.modalTitle = 'form05.title';
	            this.submitCaption = 'RC0000002';
	            //  登録画面会社リスト
	            if (this.isTohmatsu()) {
	                this.userService.getCompanyList().then(function (newMainData) {
	                    $scope.companyList = newMainData.data.companys;
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	            }
	            this.$scope.companyRole = true;
	        }
	        //  項目の表示制御
	        $scope.tohmatsu = this.isTohmatsu();
	        $scope.companyMana = !this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    UserEditController.prototype.getRecord = function (id) {
	        var _this = this;
	        this.userService.getRecord(id).then(function (data) {
	            _this.record = data.data.user;
	            _this.logName = _this.record.userName;
	            _this.record.startDate = new Date(_this.record.startDate);
	            //  編集画面会社リスト
	            if (_this.isTohmatsu()) {
	                _this.userService.getCompanyList().then(function (editMainData) {
	                    _this.$scope.companyList = editMainData.data.companys;
	                    _this.$scope.companyId = _this.record.companyId;
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	            }
	            if (_this.record.role == 2 && !_this.isReadonly()) {
	                _this.$scope.companyRole = false;
	            }
	            else {
	                _this.$scope.companyRole = true;
	            }
	            //  非活性項目制御 代表管理者
	            _this.$scope.lockItem = false;
	            _this.$scope.lockDate = false;
	            if (_this.record.managerFlag == 1) {
	                _this.$scope.lockItem = true;
	                _this.$scope.lockDate = true;
	            }
	            //  非活性制御　自身
	            var auth;
	            auth = _this.sharedService.get('auth');
	            if (auth.userId === _this.record.userId) {
	                _this.$scope.lockItem = true;
	            }
	            //  非活性制御　読取専用
	            if (_this.isReadonly()) {
	                _this.$scope.lockItem = true;
	                _this.$scope.lockDate = true;
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    UserEditController.prototype.reset = function () {
	        var _this = this;
	        this.userService.passReset(this.id).then(function (data) {
	            _this.getRecord(_this.id);
	            _this.clearAlert();
	            _this.setAlert('message.0028');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    UserEditController.prototype.delete = function () {
	        var _this = this;
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.userService.delete([this.id]).then(function (data) {
	            _this.$uibModalInstance.close('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    UserEditController.prototype.update = function () {
	        var _this = this;
	        this.record.userId = this.record.email;
	        if (this.id === null) {
	            this.userService.create(this.record).then(function (data) {
	                _this.$uibModalInstance.close('create');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.userService.update(this.record).then(function (data) {
	                _this.$uibModalInstance.close('update');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	    };
	    UserEditController.prototype.log = function () {
	        this.$uibModalInstance.close('log');
	        this.$location.url('/history/user/' + this.logName);
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    UserEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    UserEditController.prototype.show = function () { };
	    return UserEditController;
	}(PjBaseController_1.PjBaseController));
	exports.UserEditController = UserEditController;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * ユーザ情報を管理する。
	 */
	var UserService = (function (_super) {
	    __extends(UserService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function UserService($q, userApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.userApi = userApi;
	    }
	    /**
	     * 検索
	     */
	    UserService.prototype.list = function (criteria) {
	        return this.userApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 取得
	     */
	    UserService.prototype.getRecord = function (id) {
	        return this.userApi.getRecord(id).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 更新
	     */
	    UserService.prototype.update = function (record) {
	        return this.userApi.update(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 登録
	     */
	    UserService.prototype.create = function (record) {
	        return this.userApi.create(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 削除
	     */
	    UserService.prototype.delete = function (ids) {
	        return this.userApi.delete(ids).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 会社リスト取得
	     */
	    UserService.prototype.getCompanyList = function () {
	        return this.userApi.getCompanyList().then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * パスワード初期化
	     */
	    UserService.prototype.passReset = function (ids) {
	        return this.userApi.passReset(ids).then(function (data) {
	            return data;
	        });
	    };
	    return UserService;
	}(PjBaseService_1.PjBaseService));
	exports.UserService = UserService;


/***/ },
/* 48 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var UserApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function UserApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * ユーザの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/users/search', criteria);
	    };
	    /**
	     * ユーザの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.getRecord = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/users/' + id + '/edit', null);
	    };
	    /**
	     * ユーザの情報を更新する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.update = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/users/update', record);
	    };
	    /**
	     * ユーザの情報を削除する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.delete = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/users/delete', { ids: ids.join(',') });
	    };
	    /**
	     * ユーザの情報を登録する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.create = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/users/create', record);
	    };
	    /**
	     * 会社リストの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.getCompanyList = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/companies/list', null);
	    };
	    /**
	     * ユーザのパスワードを初期化する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserApi.prototype.passReset = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/users/' + ids + '/r', null);
	    };
	    return UserApi;
	}());
	exports.UserApi = UserApi;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * 履歴確認画面について出力処理およびイベント処理を行う。
	 */
	var ViewingHistoryController = (function (_super) {
	    __extends(ViewingHistoryController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function ViewingHistoryController($stateParams, $window, $translate, pjInjectProxy, viewingHistoryService, $location, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.viewingHistoryService = viewingHistoryService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form07.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'userName',
	                    displayName: 'item.0092',
	                    width: '28%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'video',
	                    displayName: 'item.0065',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'viewingDate',
	                    displayName: 'item.0044',
	                    width: '18%',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        // 検索初期条件設定
	        if ($stateParams.page === 'user') {
	            this.userName = $stateParams.name;
	        }
	        else {
	            this.video = $stateParams.name.replace(/_slash-/g, '/');
	        }
	        //  項目の表示制御
	        $scope.tohmatsu = this.isTohmatsu();
	        var auth = {};
	        auth = sharedService.get('auth');
	        if (auth && auth.role !== 2) {
	            this.gridOptions.columnDefs.unshift({
	                field: 'companyName',
	                displayName: 'item.0016',
	                headerCellFilter: 'translate'
	            });
	        }
	    }
	    ViewingHistoryController.prototype.reflesh_list = function () {
	        var _this = this;
	        this.viewingHistoryService.list(this.criteria).then(function (data) {
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.viewhistories);
	            _this.clearAlert();
	            if (data.status === 204) {
	                _this.setAlert('message.0004');
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    ViewingHistoryController.prototype.search = function () {
	        var criteria = {
	            companyName: this.companyName,
	            userName: this.userName,
	            video: this.video,
	            viewingDate: this.viewingDate
	        };
	        this.criteria = criteria;
	        this.reflesh_list();
	    };
	    ViewingHistoryController.prototype.close = function () {
	        if (this.$stateParams.page === 'user') {
	            this.$location.url('/user');
	        }
	        else if (this.$stateParams.page === 'video') {
	            this.$location.url('/video');
	        }
	        else {
	            this.$location.url('/top');
	        }
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    ViewingHistoryController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    ViewingHistoryController.prototype.show = function () { };
	    return ViewingHistoryController;
	}(PjBaseController_1.PjBaseController));
	exports.ViewingHistoryController = ViewingHistoryController;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * 履歴確認情報を管理する。
	 */
	var ViewingHistoryService = (function (_super) {
	    __extends(ViewingHistoryService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function ViewingHistoryService($q, viewingHistoryApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.viewingHistoryApi = viewingHistoryApi;
	    }
	    /**
	     * 検索
	     */
	    ViewingHistoryService.prototype.list = function (criteria) {
	        return this.viewingHistoryApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    return ViewingHistoryService;
	}(PjBaseService_1.PjBaseService));
	exports.ViewingHistoryService = ViewingHistoryService;


/***/ },
/* 51 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var ViewingHistoryApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function ViewingHistoryApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * 履歴確認の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    ViewingHistoryApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/viewhistories/search', criteria);
	    };
	    return ViewingHistoryApi;
	}());
	exports.ViewingHistoryApi = ViewingHistoryApi;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * 会社画面について出力処理およびイベント処理を行う。
	 */
	var CompanyController = (function (_super) {
	    __extends(CompanyController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function CompanyController($stateParams, $window, $uibModal, $translate, pjInjectProxy, companyService, $location, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.companyService = companyService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form09.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'companyName',
	                    displayName: 'item.0016',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.companyName}}</a>' + '<div>',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'companyCode',
	                    displayName: 'item.0013',
	                    width: '16%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'industryType',
	                    displayName: 'item.0028',
	                    width: '10%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'startDate',
	                    displayName: 'item.0094',
	                    width: '13%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'endDate',
	                    displayName: 'item.0095',
	                    width: '13%',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (!(auth.role === 3 || auth.role === 4)) {
	            this.$location.url('/top');
	        }
	        //  項目の表示制御
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    /**
	     * ダイアログ表示
	     */
	    CompanyController.prototype.show_dialog = function (id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/company/edit.html',
	            controller: 'companyEditController',
	            controllerAs: 'companyEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	                _this.clearAlert();
	                if (result === 'delete') {
	                    _this.setAlert('message.0027');
	                }
	                if (result !== 'switch') {
	                    _this.reflesh_list(result);
	                }
	            }
	        });
	    };
	    CompanyController.prototype.reflesh_list = function (result) {
	        var _this = this;
	        this.companyService.list(this.criteria).then(function (data) {
	            _this.$scope.gridApi.selection.clearSelectedRows();
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.companys);
	            if (result !== 'delete') {
	                _this.clearAlert();
	                if (data.status === 204) {
	                    _this.setAlert('message.0004');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    CompanyController.prototype.search = function () {
	        var criteria = {
	            companyName: this.companyName,
	            companyCode: this.companyCode,
	            industryType: this.industryType,
	            startDate: this.startDate,
	            endDate: this.endDate
	        };
	        this.criteria = criteria;
	        this.reflesh_list('search');
	    };
	    CompanyController.prototype.delete = function () {
	        var _this = this;
	        var rows = this.$scope.gridApi.selection.getSelectedRows();
	        if (rows.length === 0) {
	            alert(this.$translate.instant('MC0000001'));
	            return;
	        }
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.companyService.delete(rows.map(function (x) { return x.id; })).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0027');
	            _this.reflesh_list('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    CompanyController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    CompanyController.prototype.show = function () { };
	    return CompanyController;
	}(PjBaseController_1.PjBaseController));
	exports.CompanyController = CompanyController;
	var CompanyEditController = (function (_super) {
	    __extends(CompanyEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function CompanyEditController($stateParams, $uibModalInstance, $translate, pjInjectProxy, companyService, $location, sharedService, $scope, id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.companyService = companyService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        this.id = id;
	        if (id) {
	            this.modalTitle = 'form11.title';
	            this.submitCaption = 'RC0000004';
	            this.companyService.getRecord(id).then(function (data) {
	                _this.record = data.data.company;
	                _this.record.startDate = new Date(_this.record.startDate);
	                _this.record.endDate = new Date(_this.record.endDate);
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.record = {};
	            this.modalTitle = 'form10.title';
	            this.submitCaption = 'RC0000002';
	        }
	        //  項目の表示制御
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    CompanyEditController.prototype.managerLogin = function () {
	        var _this = this;
	        this.companyService.managerLogin(this.id).then(function (data) {
	            _this.userInfo = data.data.company;
	            _this.sharedService.set('auth', { role: parseInt(_this.userInfo.role), userId: _this.userInfo.userId, userName: _this.userInfo.userName, companyId: _this.userInfo.companyId, companyName: _this.userInfo.companyName });
	            _this.$uibModalInstance.close('switch');
	            _this.pjInjectProxy.$rootScope.$emit('change_authinfo', null);
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    CompanyEditController.prototype.delete = function () {
	        var _this = this;
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.companyService.delete([this.id]).then(function (data) {
	            _this.$uibModalInstance.close('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    CompanyEditController.prototype.update = function () {
	        var _this = this;
	        this.record.adminId = this.record.email;
	        if (this.id === null) {
	            this.companyService.create(this.record).then(function (data) {
	                _this.$uibModalInstance.close('create');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.companyService.update(this.record).then(function (data) {
	                _this.$uibModalInstance.close('update');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    CompanyEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    CompanyEditController.prototype.show = function () { };
	    return CompanyEditController;
	}(PjBaseController_1.PjBaseController));
	exports.CompanyEditController = CompanyEditController;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * 会社情報を管理する。
	 */
	var CompanyService = (function (_super) {
	    __extends(CompanyService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function CompanyService($q, companyApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.companyApi = companyApi;
	    }
	    /**
	     * 検索
	     */
	    CompanyService.prototype.list = function (criteria) {
	        return this.companyApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 取得
	     */
	    CompanyService.prototype.getRecord = function (id) {
	        return this.companyApi.getRecord(id).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 更新
	     */
	    CompanyService.prototype.update = function (record) {
	        return this.companyApi.update(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 登録
	     */
	    CompanyService.prototype.create = function (record) {
	        return this.companyApi.create(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 削除
	     */
	    CompanyService.prototype.delete = function (ids) {
	        return this.companyApi.delete(ids).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * ユーザ切替
	     */
	    CompanyService.prototype.managerLogin = function (id) {
	        return this.companyApi.managerLogin(id).then(function (data) {
	            return data;
	        });
	    };
	    return CompanyService;
	}(PjBaseService_1.PjBaseService));
	exports.CompanyService = CompanyService;


/***/ },
/* 54 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var CompanyApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function CompanyApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * 会社の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CompanyApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/companies/search', criteria);
	    };
	    /**
	     * 会社の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CompanyApi.prototype.getRecord = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/companies/' + id + '/edit', null);
	    };
	    /**
	     * 会社の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CompanyApi.prototype.update = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/companies/update', record);
	    };
	    /**
	     * 会社の情報を削除する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CompanyApi.prototype.delete = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/companies/delete', { ids: ids.join(',') });
	    };
	    /**
	     * 会社の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CompanyApi.prototype.create = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/companies/create', record);
	    };
	    /**
	     * ユーザ切替をする。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CompanyApi.prototype.managerLogin = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/companies/' + id + '/switch', null);
	    };
	    return CompanyApi;
	}());
	exports.CompanyApi = CompanyApi;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * グループ画面について出力処理およびイベント処理を行う。
	 */
	var GroupController = (function (_super) {
	    __extends(GroupController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function GroupController($stateParams, $window, $uibModal, $translate, pjInjectProxy, groupService, $location, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.groupService = groupService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form12.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'groupName',
	                    displayName: 'item.0035',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.groupName}}</a>' + '<div>',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (auth.role !== 2) {
	            this.$location.url('/top');
	        }
	        //  項目の表示制御
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	    }
	    /**
	     * ダイアログ表示
	     */
	    GroupController.prototype.show_dialog = function (id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/group/edit.html',
	            controller: 'groupEditController',
	            controllerAs: 'groupEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	                _this.clearAlert();
	                if (result === 'delete') {
	                    _this.setAlert('message.0027');
	                }
	                _this.reflesh_list(result);
	            }
	        });
	    };
	    GroupController.prototype.reflesh_list = function (result) {
	        var _this = this;
	        this.groupService.list(this.criteria).then(function (data) {
	            _this.$scope.gridApi.selection.clearSelectedRows();
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.groups);
	            if (result !== 'delete') {
	                _this.clearAlert();
	                if (data.status === 204) {
	                    _this.setAlert('message.0004');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    GroupController.prototype.search = function () {
	        var criteria = {
	            groupName: this.groupName
	        };
	        this.criteria = criteria;
	        this.reflesh_list('search');
	    };
	    GroupController.prototype.delete = function () {
	        var _this = this;
	        var rows = this.$scope.gridApi.selection.getSelectedRows();
	        if (rows.length === 0) {
	            alert(this.$translate.instant('MC0000001'));
	            return;
	        }
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.groupService.delete(rows.map(function (x) { return x.id; })).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0027');
	            _this.reflesh_list('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    GroupController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    GroupController.prototype.show = function () { };
	    return GroupController;
	}(PjBaseController_1.PjBaseController));
	exports.GroupController = GroupController;
	var GroupEditController = (function (_super) {
	    __extends(GroupEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function GroupEditController($stateParams, $uibModalInstance, $translate, pjInjectProxy, groupService, $location, $scope, id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.groupService = groupService;
	        this.$location = $location;
	        this.$scope = $scope;
	        this.id = id;
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'userName',
	                    displayName: 'item.0092',
	                    width: '28%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'email',
	                    displayName: 'item.0085',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'disable',
	                    displayName: 'item.0096',
	                    width: '12%',
	                    headerCellFilter: 'translate',
	                    enableFiltering: false
	                }
	            ],
	            enableFiltering: true,
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        if (id) {
	            this.modalTitle = 'form14.title';
	            this.submitCaption = 'RC0000004';
	            this.groupService.getRecord(id).then(function (data) {
	                _this.record = data.data.group;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	            this.getEditUserList(id);
	        }
	        else {
	            this.record = {};
	            this.modalTitle = 'form13.title';
	            this.submitCaption = 'RC0000002';
	            this.getNewUserList();
	        }
	        //  項目の表示制御
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	    }
	    GroupEditController.prototype.getNewUserList = function () {
	        var _this = this;
	        this.groupService.getNewUserList().then(function (data) {
	            if (_this.gridOptions.data === undefined || _this.gridOptions.data === null) {
	                _this.gridOptions.data = data.data.groups;
	            }
	            else {
	                _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	                Array.prototype.push.apply(_this.gridOptions.data, data.data.groups);
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    GroupEditController.prototype.getEditUserList = function (id) {
	        var _this = this;
	        this.groupService.getEditUserList(id).then(function (data) {
	            if (_this.gridOptions.data === undefined || _this.gridOptions.data === null) {
	                _this.gridOptions.data = data.data.groups;
	            }
	            else {
	                _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	                Array.prototype.push.apply(_this.gridOptions.data, data.data.groups);
	            }
	            _this.$scope.gridApi.grid.modifyRows(_this.gridOptions.data);
	            for (var i = 0; i < _this.gridOptions.data.length; i++) {
	                if (_this.gridOptions.data[i].selectFlag === '1') {
	                    _this.$scope.gridApi.selection.selectRow(_this.gridOptions.data[i]);
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    GroupEditController.prototype.delete = function () {
	        var _this = this;
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.groupService.delete([this.id]).then(function (data) {
	            _this.$uibModalInstance.close('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    GroupEditController.prototype.update = function () {
	        var _this = this;
	        this.record.chkUserId = this.$scope.gridApi.selection.getSelectedRows().map(function (x) { return x.userId; }).join(',');
	        if (this.id === null) {
	            this.groupService.create(this.record).then(function (data) {
	                _this.$uibModalInstance.close('create');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.groupService.update(this.record).then(function (data) {
	                _this.$uibModalInstance.close('update');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    GroupEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    GroupEditController.prototype.show = function () { };
	    return GroupEditController;
	}(PjBaseController_1.PjBaseController));
	exports.GroupEditController = GroupEditController;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * グループ情報を管理する。
	 */
	var GroupService = (function (_super) {
	    __extends(GroupService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function GroupService($q, groupApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.groupApi = groupApi;
	    }
	    /**
	     * 検索
	     */
	    GroupService.prototype.list = function (criteria) {
	        return this.groupApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 取得
	     */
	    GroupService.prototype.getRecord = function (id) {
	        return this.groupApi.getRecord(id).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 更新
	     */
	    GroupService.prototype.update = function (record) {
	        return this.groupApi.update(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 登録
	     */
	    GroupService.prototype.create = function (record) {
	        return this.groupApi.create(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 削除
	     */
	    GroupService.prototype.delete = function (ids) {
	        return this.groupApi.delete(ids).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * ユーザリスト取得(登録時)
	     */
	    GroupService.prototype.getNewUserList = function () {
	        return this.groupApi.getNewUserList().then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * ユーザリスト取得(編集時)
	     */
	    GroupService.prototype.getEditUserList = function (id) {
	        return this.groupApi.getEditUserList(id).then(function (data) {
	            return data;
	        });
	    };
	    return GroupService;
	}(PjBaseService_1.PjBaseService));
	exports.GroupService = GroupService;


/***/ },
/* 57 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var GroupApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function GroupApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * グループの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    GroupApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/groups/search', criteria);
	    };
	    /**
	     * グループの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    GroupApi.prototype.getRecord = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/groups/' + id + '/edit', null);
	    };
	    /**
	     * グループの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    GroupApi.prototype.update = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/groups/update', record);
	    };
	    /**
	     * グループの情報を削除する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    GroupApi.prototype.delete = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/groups/delete', { ids: ids.join(',') });
	    };
	    /**
	     * グループの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    GroupApi.prototype.create = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/groups/create', record);
	    };
	    /**
	     * ユーザの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    GroupApi.prototype.getNewUserList = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/groups/insert', null);
	    };
	    /**
	     * ユーザの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    GroupApi.prototype.getEditUserList = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/groups/' + id + '/list', null);
	    };
	    return GroupApi;
	}());
	exports.GroupApi = GroupApi;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * 動画画面について出力処理およびイベント処理を行う。
	 */
	var VideoController = (function (_super) {
	    __extends(VideoController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function VideoController($stateParams, $window, $uibModal, $translate, pjInjectProxy, videoService, $location, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.videoService = videoService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form15.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'title',
	                    displayName: 'item.0065',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.title}}</a>' + '<div>',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'mainCategory',
	                    displayName: 'item.0083',
	                    width: '20%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'subCategory',
	                    displayName: 'item.0105',
	                    width: '20%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'distributionDate',
	                    displayName: 'item.0071',
	                    width: '13%',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	        //  メインカテゴリリスト取得
	        this.videoService.getMainCategoryList().then(function (mainData) {
	            $scope.mainCategoryList = {};
	            $scope.mainCategoryList = mainData.data.categories;
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (!(auth.role === 2 || auth.role === 3 || auth.role === 4)) {
	            this.$location.url('/top');
	        }
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	        if (auth.role === 2) {
	            //  項目の表示制御(会社)
	            $scope.readUser = !this.isTohmatsu();
	            $scope.readUserBtn = this.isTohmatsu();
	        }
	    }
	    /**
	     * ダイアログ表示
	     */
	    VideoController.prototype.show_dialog = function (id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/video/edit.html',
	            controller: 'videoEditController',
	            controllerAs: 'videoEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	                _this.clearAlert();
	                if (result === 'delete') {
	                    _this.setAlert('message.0027');
	                }
	                _this.reflesh_list(result);
	            }
	        });
	    };
	    VideoController.prototype.reflesh_list = function (result) {
	        var _this = this;
	        this.videoService.list(this.criteria).then(function (data) {
	            _this.$scope.gridApi.selection.clearSelectedRows();
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.videos);
	            if (result !== 'delete') {
	                _this.clearAlert();
	                if (data.status === 204) {
	                    _this.setAlert('message.0004');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    VideoController.prototype.search = function () {
	        var criteria = {
	            title: this.title,
	            categoryId: this.$scope.mainSelectedItem || null,
	            description: this.description,
	            distributionDate: this.distributionDate
	        };
	        this.criteria = criteria;
	        this.reflesh_list('search');
	    };
	    VideoController.prototype.delete = function () {
	        var _this = this;
	        var rows = this.$scope.gridApi.selection.getSelectedRows();
	        if (rows.length === 0) {
	            alert(this.$translate.instant('MC0000001'));
	            return;
	        }
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.videoService.delete(rows.map(function (x) { return x.id; })).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0027');
	            _this.reflesh_list('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    VideoController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    VideoController.prototype.show = function () { };
	    return VideoController;
	}(PjBaseController_1.PjBaseController));
	exports.VideoController = VideoController;
	var VideoEditController = (function (_super) {
	    __extends(VideoEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function VideoEditController($stateParams, $uibModalInstance, $translate, pjInjectProxy, videoService, $scope, $location, sharedService, $timeout, id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.videoService = videoService;
	        this.$scope = $scope;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$timeout = $timeout;
	        this.id = id;
	        // サブカテゴリセレクトボックス数管理配列
	        this.subSelectedItem = [];
	        this.changeItem = function () {
	            var _this = this;
	            var delCnt = this.subSelectedItem.length;
	            for (var i = 0; i < delCnt; i++) {
	                this.subSelectedItem.pop();
	            }
	            this.$scope.subCategoryList = [];
	            if (!this.$scope.mainSelectedItem) {
	                return;
	            }
	            this.videoService.getSubCategoryList(this.$scope.mainSelectedItem).then(function (newSubData) {
	                _this.$scope.subCategoryList = newSubData.data.categories;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        };
	        if (id) {
	            this.modalTitle = 'form17.title';
	            this.submitCaption = 'RC0000004';
	            this.videoService.getRecord(id).then(function (data) {
	                data.data.video.thumbnailUrl = data.data.video.thumbnailUrl + '?m=' + new Date().getTime();
	                _this.record = data.data.video;
	                _this.logName = _this.record.title;
	                //  メインカテゴリリスト取得
	                _this.videoService.getMainCategoryList().then(function (editMainData) {
	                    $scope.mainCategoryList = editMainData.data.categories;
	                    $scope.mainSelectedItem = _this.record.mainCategoryId;
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	                //  サブカテゴリリスト取得
	                _this.videoService.getSubCategoryList(_this.record.mainCategoryId).then(function (editSubData) {
	                    $scope.subCategoryList = editSubData.data.categories;
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	                if (_this.record.subCategoryId !== 'null') {
	                    //  this.record.subCategoryIdの要素数を区切り、数をカウント
	                    var str = _this.record.subCategoryId;
	                    var ary = str.split(',');
	                    //  各セレクトボックスにバルクの中身を設定
	                    for (var j = 0; j < ary.length; j++) {
	                        _this.subSelectedItem.push(ary[j]);
	                    }
	                }
	                _this.record.distributionDate = new Date(_this.record.distributionDate);
	                _this.videoService.url(_this.record.videoUrl).then(function (url) {
	                    _this.videoUrl = url.data.video.videoUrl; // + '?m=' + new Date().getTime();
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	                //                let desc = this.record.description;
	                //                this.record.description = '動画説明';
	                //
	                //                this.$timeout(function(arg) {
	                //                    let record = arg;
	                //                    return function() {
	                //                        record.description = desc;
	                //                    };
	                //                }(this.record), 500);
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.record = {};
	            this.modalTitle = 'form16.title';
	            this.submitCaption = 'RC0000002';
	            //  メインカテゴリリスト
	            this.videoService.getMainCategoryList().then(function (newMainData) {
	                $scope.mainCategoryList = newMainData.data.categories;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        var auth;
	        auth = sharedService.get('auth');
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	        $scope.comManager = true;
	        if (auth.role === 2) {
	            //  項目の表示制御(会社)
	            $scope.readUser = !this.isTohmatsu();
	            $scope.readUserBtn = this.isTohmatsu();
	            $scope.comManager = false;
	        }
	    }
	    VideoEditController.prototype.delete = function () {
	        var _this = this;
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.videoService.delete([this.id]).then(function (data) {
	            _this.$uibModalInstance.close('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    VideoEditController.prototype.update = function () {
	        var _this = this;
	        this.record.subCategoryId = this.subSelectedItem.filter(function (x, i, self) {
	            return self.indexOf(x) === i && x !== '';
	        }).join(',');
	        this.record.mainCategoryId = this.$scope.mainSelectedItem;
	        console.log(this.record);
	        if (this.id === null) {
	            this.videoService.create(this.record, this.video, this.thumbnail).then(function (data) {
	                _this.$uibModalInstance.close('create');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.videoService.update(this.record, this.video, this.thumbnail).then(function (data) {
	                _this.$uibModalInstance.close('update');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	    };
	    // 追加削除button
	    VideoEditController.prototype.add = function () {
	        this.subSelectedItem.push('');
	    };
	    VideoEditController.prototype.del = function (indexNum) {
	        this.subSelectedItem.splice(indexNum, 1);
	    };
	    VideoEditController.prototype.log = function () {
	        this.$uibModalInstance.close('log');
	        this.$location.url('/history/video/' + this.logName.replace(/\//g, '_slash-'));
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    VideoEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    VideoEditController.prototype.show = function () { };
	    return VideoEditController;
	}(PjBaseController_1.PjBaseController));
	exports.VideoEditController = VideoEditController;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * 動画情報を管理する。
	 */
	var VideoService = (function (_super) {
	    __extends(VideoService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function VideoService($q, videoApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.videoApi = videoApi;
	    }
	    /**
	     * 検索
	     */
	    VideoService.prototype.list = function (criteria) {
	        return this.videoApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 取得
	     */
	    VideoService.prototype.getRecord = function (id) {
	        return this.videoApi.getRecord(id).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 更新
	     */
	    VideoService.prototype.update = function (record, video, thumbnail) {
	        return this.videoApi.update(record, video, thumbnail).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * URL
	     */
	    VideoService.prototype.url = function (url) {
	        return this.videoApi.url(url).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 登録
	     */
	    VideoService.prototype.create = function (record, video, thumbnail) {
	        return this.videoApi.create(record, video, thumbnail).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 削除
	     */
	    VideoService.prototype.delete = function (ids) {
	        return this.videoApi.delete(ids).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * メインカテゴリリスト取得
	     */
	    VideoService.prototype.getMainCategoryList = function () {
	        return this.videoApi.getMainCategoryList().then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * サブカテゴリリスト取得
	     */
	    VideoService.prototype.getSubCategoryList = function (mainId) {
	        return this.videoApi.getSubCategoryList(mainId).then(function (data) {
	            return data;
	        });
	    };
	    return VideoService;
	}(PjBaseService_1.PjBaseService));
	exports.VideoService = VideoService;


/***/ },
/* 60 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var VideoApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function VideoApi($http, $q, $httpParamSerializer, basePath, $net, Upload) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        this.Upload = Upload;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * 動画の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    VideoApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/videos/list', criteria);
	    };
	    /**
	     * 動画の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    VideoApi.prototype.getRecord = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/videos/' + id + '/edit', null);
	    };
	    /**
	     * 動画の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    VideoApi.prototype.update = function (record, video, thumbnail, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        var param = this.$net.createParam(record);
	        param.video = video;
	        param.thumbnail = thumbnail;
	        return this.Upload.upload({
	            url: this.basePath + '/videos/update',
	            fields: param
	        });
	    };
	    /**
	     * 動画の情報を削除する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    VideoApi.prototype.delete = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/videos/delete', { ids: ids.join(',') });
	    };
	    /**
	     * 動画のURLを取得する。
	     * @param url  動画URL
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    VideoApi.prototype.url = function (url, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get(url);
	    };
	    /**
	     * 動画の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    VideoApi.prototype.create = function (record, video, thumbnail, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        var param = this.$net.createParam(record);
	        param.video = video;
	        param.thumbnail = thumbnail;
	        return this.Upload.upload({
	            url: this.basePath + '/videos/create',
	            fields: param
	        });
	    };
	    /**
	     * メインカテゴリリストの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    VideoApi.prototype.getMainCategoryList = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/categories/listAll', null);
	    };
	    /**
	     * サブカテゴリの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    VideoApi.prototype.getSubCategoryList = function (mainId, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/categories/' + mainId + '/listAll', null);
	    };
	    return VideoApi;
	}());
	exports.VideoApi = VideoApi;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * カテゴリ画面について出力処理およびイベント処理を行う。
	 */
	var CategoryController = (function (_super) {
	    __extends(CategoryController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function CategoryController($stateParams, $window, $uibModal, $translate, pjInjectProxy, categoryService, $location, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.categoryService = categoryService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form18.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'mainCategory',
	                    displayName: 'item.0083',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show([row.entity.mainId,null])">{{row.entity.mainCategory}}</a>' + '<div>',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'subCategory',
	                    displayName: 'item.0105',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show([row.entity.mainId,row.entity.subId])">{{row.entity.subCategory}}</a>' + '<div>',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	        //  メインカテゴリリスト取得
	        this.getMainList();
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (!(auth.role === 3 || auth.role === 4)) {
	            this.$location.url('/top');
	        }
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    /**
	     * ダイアログ表示
	     */
	    CategoryController.prototype.show_dialog = function (id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/category/edit.html',
	            controller: 'categoryEditController',
	            controllerAs: 'categoryEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	                _this.clearAlert();
	                if (result === 'delete') {
	                    _this.setAlert('message.0027');
	                }
	                _this.reflesh_list(result);
	                _this.getMainList();
	            }
	        });
	    };
	    CategoryController.prototype.reflesh_list = function (result) {
	        var _this = this;
	        this.categoryService.list(this.criteria).then(function (data) {
	            _this.$scope.gridApi.selection.clearSelectedRows();
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.categories);
	            if (result !== 'delete') {
	                _this.clearAlert();
	                if (data.status === 204) {
	                    _this.setAlert('message.0004');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    CategoryController.prototype.search = function () {
	        var criteria = {
	            mainId: this.$scope.selectedItem || null
	        };
	        this.criteria = criteria;
	        this.reflesh_list('search');
	    };
	    CategoryController.prototype.delete = function () {
	        var _this = this;
	        this.deleteList = null;
	        var rows = this.$scope.gridApi.selection.getSelectedRows();
	        if (rows.length === 0) {
	            alert(this.$translate.instant('MC0000001'));
	            return;
	        }
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        var main = this.$scope.gridApi.selection.getSelectedRows().map(function (x) { return x.subId === null ? x.mainId : null; }).filter(function (x, i, self) {
	            return self.indexOf(x) === i && x !== null && x !== '';
	        }).join(',');
	        var sub = this.$scope.gridApi.selection.getSelectedRows().map(function (x) { return x.subId; }).filter(function (x, i, self) {
	            return self.indexOf(x) === i && x !== null && x !== '';
	        }).join(',');
	        this.deleteList = {
	            mainIds: main,
	            subIds: sub
	        };
	        this.categoryService.delete(this.deleteList).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0027');
	            _this.reflesh_list('delete');
	            //  メインカテゴリリスト取得
	            _this.getMainList();
	            var delMainId = main.split(',');
	            if (delMainId.filter(function (x) { return x === _this.$scope.selectedItem; }).length) {
	                _this.$scope.selectedItem = null;
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    CategoryController.prototype.getMainList = function () {
	        var _this = this;
	        //  メインカテゴリリスト取得
	        this.categoryService.getMainCategoryList().then(function (mainData) {
	            _this.$scope.mainCategoryList = mainData.data.categories;
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    CategoryController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    CategoryController.prototype.show = function () { };
	    return CategoryController;
	}(PjBaseController_1.PjBaseController));
	exports.CategoryController = CategoryController;
	var CategoryEditController = (function (_super) {
	    __extends(CategoryEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function CategoryEditController($stateParams, $uibModalInstance, $translate, pjInjectProxy, categoryService, $location, $scope, id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.categoryService = categoryService;
	        this.$location = $location;
	        this.$scope = $scope;
	        this.id = id;
	        // 削除情報
	        this.deleteInfo = null;
	        if (id) {
	            this.modalTitle = 'form20.title';
	            this.submitCaption = 'RC0000004';
	            this.categoryService.getRecord(id).then(function (data) {
	                _this.record = data.data.category;
	                _this.lastMainId = _this.record.mainId;
	                //  メインカテゴリリスト取得
	                _this.categoryService.getMainCategoryList().then(function (editMainData) {
	                    $scope.mainCategoryList = editMainData.data.categories;
	                    //  メインカテゴリ編集時は親カテゴリを表示しないため、一旦nullセット
	                    if (id[1] === null) {
	                        _this.record.mainId = null;
	                    }
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	                $scope.mainEdit = true;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.record = {};
	            this.modalTitle = 'form19.title';
	            this.submitCaption = 'RC0000002';
	            //  メインカテゴリリスト取得
	            this.categoryService.getMainCategoryList().then(function (mainData) {
	                $scope.mainCategoryList = mainData.data.categories;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    CategoryEditController.prototype.delete = function () {
	        var _this = this;
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        var deleteId = {
	            mainIds: this.id[1] === null ? this.id[0] : null,
	            subIds: this.id[1]
	        };
	        this.deleteInfo = deleteId;
	        this.categoryService.delete(this.deleteInfo).then(function (data) {
	            _this.$uibModalInstance.close('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    CategoryEditController.prototype.update = function () {
	        var _this = this;
	        if (this.id === null) {
	            if (this.record.mainId === '') {
	                this.record.mainId = null;
	            }
	            this.categoryService.create(this.record).then(function (data) {
	                _this.$uibModalInstance.close('create');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            var sendData = {
	                category: this.record.category,
	                mainId: this.lastMainId,
	                subId: this.record.subId,
	                version: this.record.version
	            };
	            this.categoryService.update(sendData).then(function (data) {
	                _this.$uibModalInstance.close('update');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    CategoryEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    CategoryEditController.prototype.show = function () { };
	    return CategoryEditController;
	}(PjBaseController_1.PjBaseController));
	exports.CategoryEditController = CategoryEditController;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * カテゴリ情報を管理する。
	 */
	var CategoryService = (function (_super) {
	    __extends(CategoryService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function CategoryService($q, categoryApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.categoryApi = categoryApi;
	    }
	    /**
	     * 検索
	     */
	    CategoryService.prototype.list = function (criteria) {
	        return this.categoryApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 取得
	     */
	    CategoryService.prototype.getRecord = function (id) {
	        return this.categoryApi.getRecord(id).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 更新
	     */
	    CategoryService.prototype.update = function (record) {
	        return this.categoryApi.update(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 登録
	     */
	    CategoryService.prototype.create = function (record) {
	        return this.categoryApi.create(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 削除
	     */
	    CategoryService.prototype.delete = function (ids) {
	        return this.categoryApi.delete(ids).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * メインカテゴリリスト取得
	     */
	    CategoryService.prototype.getMainCategoryList = function () {
	        return this.categoryApi.getMainCategoryList().then(function (data) {
	            return data;
	        });
	    };
	    return CategoryService;
	}(PjBaseService_1.PjBaseService));
	exports.CategoryService = CategoryService;


/***/ },
/* 63 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var CategoryApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function CategoryApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * カテゴリの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CategoryApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/categories/search', criteria);
	    };
	    /**
	     * カテゴリの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CategoryApi.prototype.getRecord = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        if (id[1] !== null) {
	            return this.$net.get('/categories/' + id[0] + '/' + id[1] + '/editSub', null);
	        }
	        else {
	            return this.$net.get('/categories/' + id[0] + '/editMain', null);
	        }
	    };
	    /**
	     * カテゴリの情報を更新する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CategoryApi.prototype.update = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/categories/update', record);
	    };
	    /**
	     * カテゴリの情報を削除する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CategoryApi.prototype.delete = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/categories/delete', ids);
	    };
	    /**
	     * カテゴリの情報を登録する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CategoryApi.prototype.create = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/categories/create', record);
	    };
	    /**
	     * メインカテゴリリストの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    CategoryApi.prototype.getMainCategoryList = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/categories/listAll', null);
	    };
	    return CategoryApi;
	}());
	exports.CategoryApi = CategoryApi;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * おすすめ画面について出力処理およびイベント処理を行う。
	 */
	var RecommendController = (function (_super) {
	    __extends(RecommendController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function RecommendController($stateParams, $window, $uibModal, $translate, pjInjectProxy, recommendService, $location, $http, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.recommendService = recommendService;
	        this.$location = $location;
	        this.$http = $http;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form21.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'title',
	                    displayName: 'item.0008',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.title}}</a>' + '<div>',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'videoCount',
	                    displayName: 'item.0108',
	                    width: '13%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'groupCount',
	                    displayName: 'item.0107',
	                    width: '17%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'startDate',
	                    displayName: 'item.0011',
	                    width: '11%',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'endDate',
	                    displayName: 'item.0047',
	                    width: '11%',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (auth.role !== 2) {
	            this.$location.url('/top');
	        }
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	    }
	    /**
	     * ダイアログ表示
	     */
	    RecommendController.prototype.show_dialog = function (id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/recommend/edit.html',
	            controller: 'recommendEditController',
	            controllerAs: 'recommendEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	                _this.clearAlert();
	                if (result === 'delete') {
	                    _this.setAlert('message.0027');
	                }
	                _this.reflesh_list(result);
	            }
	        });
	    };
	    RecommendController.prototype.reflesh_list = function (result) {
	        var _this = this;
	        this.recommendService.list(this.criteria).then(function (data) {
	            _this.$scope.gridApi.selection.clearSelectedRows();
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.recommends);
	            if (result !== 'delete') {
	                _this.clearAlert();
	                if (data.status === 204) {
	                    _this.setAlert('message.0004');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    RecommendController.prototype.search = function () {
	        var criteria = {
	            title: this.title,
	            startDate: this.startDate,
	            endDate: this.endDate
	        };
	        this.criteria = criteria;
	        this.reflesh_list('search');
	    };
	    RecommendController.prototype.delete = function () {
	        var _this = this;
	        var rows = this.$scope.gridApi.selection.getSelectedRows();
	        if (rows.length === 0) {
	            alert(this.$translate.instant('MC0000001'));
	            return;
	        }
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.recommendService.delete(rows.map(function (x) { return x.id; })).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0027');
	            _this.reflesh_list('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    RecommendController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    RecommendController.prototype.show = function () { };
	    return RecommendController;
	}(PjBaseController_1.PjBaseController));
	exports.RecommendController = RecommendController;
	var RecommendEditController = (function (_super) {
	    __extends(RecommendEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function RecommendEditController($stateParams, $uibModalInstance, $translate, pjInjectProxy, recommendService, $location, $scope, uiSortableMultiSelectionMethods, id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.recommendService = recommendService;
	        this.$location = $location;
	        this.$scope = $scope;
	        this.uiSortableMultiSelectionMethods = uiSortableMultiSelectionMethods;
	        this.id = id;
	        // グループボックス数管理配列
	        this.groupSelectedItem = [];
	        // グループボックス数管理配列
	        this.groupSelectedItemSub = [];
	        // 選択肢
	        this.selected = [];
	        // 登録対象
	        this.targets = [];
	        if (id) {
	            this.modalTitle = 'form23.title';
	            this.submitCaption = 'RC0000004';
	            this.gridOptions = {
	                columnDefs: [
	                    {
	                        field: 'userName',
	                        displayName: 'item.0092',
	                        width: '28%',
	                        headerCellFilter: 'translate'
	                    },
	                    {
	                        field: 'title',
	                        displayName: 'item.0065',
	                        headerCellFilter: 'translate'
	                    },
	                    {
	                        field: 'groupName',
	                        displayName: 'item.0035',
	                        headerCellFilter: 'translate'
	                    },
	                    {
	                        field: 'viewingDate',
	                        displayName: 'item.0044',
	                        width: '18%',
	                        headerCellFilter: 'translate',
	                        enableFiltering: false
	                    }
	                ],
	                enableFiltering: true,
	                enableColumnMenus: false,
	                enableHorizontalScrollbar: 0,
	                enableColumnResizing: true,
	                paginationPageSizes: [10, 25, 100],
	                paginationPageSize: 10,
	                onRegisterApi: function (gridApi) {
	                    _this.$scope.gridApi = gridApi;
	                },
	            };
	            this.draw();
	            this.recommendService.getRecord(id).then(function (data) {
	                _this.record = data.data.recommend;
	                //  グループリスト取得
	                _this.recommendService.getGroupList().then(function (editMainData) {
	                    $scope.groupList = editMainData.data.groups;
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	                //  this.record.groupIdの要素数を区切り配列化
	                var groupStr = _this.record.groupId;
	                var groupAry = groupStr.split(',');
	                //  先頭のgroupIdのみgroupSelectedItemに設定
	                _this.groupSelectedItem = groupAry[0];
	                //  先頭以外の登録済みグループリストを設定
	                for (var i = 1; i < groupAry.length; i++) {
	                    _this.groupSelectedItemSub.push(groupAry[i]);
	                }
	                //  パックリスト取得
	                _this.recommendService.getPackList().then(function (editMainData) {
	                    $scope.packList = editMainData.data.packs;
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	                //  this.record.videoIdから、登録済み動画をthis.targetsに描画する
	                //  this.record.groupIdの要素数を区切り、数をカウント
	                var videoStr = _this.record.videoId;
	                var videoIdAry;
	                if (videoStr == "null") {
	                    videoIdAry = [];
	                }
	                else {
	                    videoIdAry = videoStr.split(',');
	                }
	                //  videotitleを格納
	                var videoTitleAry = _this.record.videoTitle;
	                //  配列結合
	                var inList = [];
	                for (var j = 0; j < videoIdAry.length; j++) {
	                    inList.push({ 'id': videoIdAry[j], 'title': videoTitleAry[j] });
	                }
	                //  選択済みリストを表示
	                _this.selected = [];
	                _this.targets = inList;
	                _this.record.startDate = new Date(_this.record.startDate);
	                _this.record.endDate = new Date(_this.record.endDate);
	                //  視聴履歴の表示制御
	                $scope.log = true;
	                _this.getUserHistory(id);
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.record = {};
	            this.modalTitle = 'form22.title';
	            this.submitCaption = 'RC0000002';
	            //  グループリスト取得
	            this.recommendService.getGroupList().then(function (newMainData) {
	                _this.groupSelectedItem = null;
	                $scope.groupList = newMainData.data.groups;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	            //  パックリスト取得
	            this.recommendService.getPackList().then(function (editMainData) {
	                $scope.packList = editMainData.data.packs;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	            this.selected = [];
	            this.targets = [];
	            //  視聴履歴の表示制御
	            $scope.log = false;
	        }
	        this.sortableOptions = uiSortableMultiSelectionMethods.extendOptions({
	            'axis ': 'y',
	            'cursorAt': { top: 25 },
	            'start': function (event, ui) {
	            },
	            'stop': function (event, ui) {
	            },
	            'connectWith': '.apps-container',
	            'placeholder': 'app',
	            'update': function (event, ui) {
	                if (ui.item.sortable.received) {
	                    return;
	                }
	                if (ui.item.sortable.sourceModel === _this.selected &&
	                    ui.item.sortable.droptargetModel === _this.targets) {
	                    var _loop_1 = function(i) {
	                        if (_this.targets.filter(function (x) { return x.id === ui.item.sortableMultiSelect.selectedModels[i].id; }).length) {
	                            ui.item.sortable.cancel();
	                            window.alert(_this.$translate.instant('message.0050'));
	                            return "break";
	                        }
	                    };
	                    for (var i = 0; i < ui.item.sortableMultiSelect.selectedModels.length; i++) {
	                        var state_1 = _loop_1(i);
	                        if (state_1 === "break") break;
	                    }
	                }
	            }
	        });
	    }
	    RecommendEditController.prototype.searchVideo = function () {
	        var _this = this;
	        this.selected = [];
	        var criteria = {
	            title: this.videoTitle,
	            packId: this.$scope.packSelectedItem || null
	        };
	        this.recommendService.getVideoList(criteria).then(function (data) {
	            _this.clearAlert();
	            if (data.status === 204) {
	                _this.setAlert('message.0004');
	            }
	            else {
	                var dataLength = data.data.recommends.length;
	                _this.selected = data.data.recommends.splice(0, 100);
	                if (dataLength > 100) {
	                    _this.setAlert('message.0048');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    RecommendEditController.prototype.getUserHistory = function (id) {
	        var _this = this;
	        this.recommendService.getUserHistory(id).then(function (data) {
	            if (_this.gridOptions.data === undefined || _this.gridOptions.data === null) {
	                _this.gridOptions.data = data.data.recommends;
	            }
	            else {
	                _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	                Array.prototype.push.apply(_this.gridOptions.data, data.data.recommends);
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    RecommendEditController.prototype.delete = function () {
	        var _this = this;
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.recommendService.delete([this.id]).then(function (data) {
	            _this.$uibModalInstance.close('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    RecommendEditController.prototype.update = function () {
	        var _this = this;
	        //  登録対象の動画重複チェック
	        var targetId = [];
	        var targetLen = this.targets.length || 0;
	        for (var i = 0; i < targetLen; i++) {
	            targetId.push(this.targets[i].id);
	        }
	        var c = targetId.filter(function (x, i, self) {
	            return self.indexOf(x) !== self.lastIndexOf(x);
	        });
	        if (c.length !== 0) {
	            console.log('NG');
	            //    window.alert(this.$translate.instant('message.0050'));
	            return;
	        }
	        // グループID重複チェック
	        var dammyGrp;
	        dammyGrp = this.groupSelectedItem.split(',');
	        dammyGrp = dammyGrp.concat(this.groupSelectedItemSub);
	        dammyGrp = dammyGrp.filter(function (x, i, self) {
	            return x !== '';
	        });
	        // 選択されたグループIDの総数
	        var allGrpIdCnt = dammyGrp.length;
	        var dammyGrp2 = dammyGrp.filter(function (x, i, self) {
	            return self.indexOf(x) === i && x !== '';
	        });
	        // 重複を除外したグループIDの数
	        var selGrpIdCnt = dammyGrp2.length;
	        if (allGrpIdCnt !== selGrpIdCnt) {
	            this.clearAlert();
	            this.setAlert('message.0059');
	            return;
	        }
	        this.record.videoId = this.targets.map(function (x) { return x.id; }).filter(function (x, i, self) {
	            return self.indexOf(x) === i && x !== '';
	        }).join(',');
	        this.record.groupId = dammyGrp.filter(function (x, i, self) {
	            return self.indexOf(x) === i && x !== '';
	        }).join(',');
	        if (this.id === null) {
	            this.recommendService.create(this.record).then(function (data) {
	                _this.$uibModalInstance.close('create');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.recommendService.update(this.record).then(function (data) {
	                _this.$uibModalInstance.close('update');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	    };
	    // 追加削除button
	    RecommendEditController.prototype.add = function () {
	        this.groupSelectedItemSub.push('');
	    };
	    RecommendEditController.prototype.del = function (indexNum) {
	        this.groupSelectedItemSub.splice(indexNum, 1);
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    RecommendEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    RecommendEditController.prototype.show = function () { };
	    return RecommendEditController;
	}(PjBaseController_1.PjBaseController));
	exports.RecommendEditController = RecommendEditController;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * おすすめ情報を管理する。
	 */
	var RecommendService = (function (_super) {
	    __extends(RecommendService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function RecommendService($q, recommendApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.recommendApi = recommendApi;
	    }
	    /**
	     * 検索
	     */
	    RecommendService.prototype.list = function (criteria) {
	        return this.recommendApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 取得
	     */
	    RecommendService.prototype.getRecord = function (id) {
	        return this.recommendApi.getRecord(id).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 更新
	     */
	    RecommendService.prototype.update = function (record) {
	        return this.recommendApi.update(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 登録
	     */
	    RecommendService.prototype.create = function (record) {
	        return this.recommendApi.create(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 削除
	     */
	    RecommendService.prototype.delete = function (ids) {
	        return this.recommendApi.delete(ids).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * グループリスト取得
	     */
	    RecommendService.prototype.getGroupList = function () {
	        return this.recommendApi.getGroupList().then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * パックリスト取得
	     */
	    RecommendService.prototype.getPackList = function () {
	        return this.recommendApi.getPackList().then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 動画リスト取得
	     */
	    RecommendService.prototype.getVideoList = function (videoCriteria) {
	        return this.recommendApi.getVideoList(videoCriteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 視聴履歴取得
	     */
	    RecommendService.prototype.getUserHistory = function (id) {
	        return this.recommendApi.getUserHistory(id).then(function (data) {
	            return data;
	        });
	    };
	    return RecommendService;
	}(PjBaseService_1.PjBaseService));
	exports.RecommendService = RecommendService;


/***/ },
/* 66 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var RecommendApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function RecommendApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * おすすめの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    RecommendApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/recommends/search', criteria);
	    };
	    /**
	     * おすすめの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    RecommendApi.prototype.getRecord = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/recommends/' + id + '/edit', null);
	    };
	    /**
	     * おすすめの情報を更新する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    RecommendApi.prototype.update = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/recommends/update', record);
	    };
	    /**
	     * おすすめの情報を削除する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    RecommendApi.prototype.delete = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/recommends/delete', { ids: ids.join(',') });
	    };
	    /**
	     * おすすめの情報を登録する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    RecommendApi.prototype.create = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/recommends/create', record);
	    };
	    /**
	     * グループリストの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    RecommendApi.prototype.getGroupList = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/groups/list', null);
	    };
	    /**
	     * パックリストの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    RecommendApi.prototype.getPackList = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/packs/list', null);
	    };
	    /**
	     * パックの動画情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    RecommendApi.prototype.getVideoList = function (videoCriteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/recommends/pack/', videoCriteria);
	    };
	    /**
	     * 視聴履歴情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    RecommendApi.prototype.getUserHistory = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/recommends/' + id + '/history', null);
	    };
	    return RecommendApi;
	}());
	exports.RecommendApi = RecommendApi;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * シリーズ画面について出力処理およびイベント処理を行う。
	 */
	var SeriesController = (function (_super) {
	    __extends(SeriesController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function SeriesController($stateParams, $window, $uibModal, $translate, pjInjectProxy, seriesService, $location, $http, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.seriesService = seriesService;
	        this.$location = $location;
	        this.$http = $http;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form24.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'title',
	                    displayName: 'item.0053',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.title}}</a>' + '<div>',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'videoCount',
	                    displayName: 'item.0108',
	                    width: '13%',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (!(auth.role === 3 || auth.role === 4)) {
	            this.$location.url('/top');
	        }
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    /**
	     * ダイアログ表示
	     */
	    SeriesController.prototype.show_dialog = function (id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/series/edit.html',
	            controller: 'seriesEditController',
	            controllerAs: 'seriesEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	                _this.clearAlert();
	                if (result === 'delete') {
	                    _this.setAlert('message.0027');
	                }
	                _this.reflesh_list(result);
	            }
	        });
	    };
	    SeriesController.prototype.reflesh_list = function (result) {
	        var _this = this;
	        this.seriesService.list(this.criteria).then(function (data) {
	            _this.$scope.gridApi.selection.clearSelectedRows();
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.series);
	            if (result !== 'delete') {
	                _this.clearAlert();
	                if (data.status === 204) {
	                    _this.setAlert('message.0004');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    SeriesController.prototype.search = function () {
	        var criteria = {
	            title: this.title
	        };
	        this.criteria = criteria;
	        this.reflesh_list('search');
	    };
	    SeriesController.prototype.delete = function () {
	        var _this = this;
	        var rows = this.$scope.gridApi.selection.getSelectedRows();
	        if (rows.length === 0) {
	            alert(this.$translate.instant('MC0000001'));
	            return;
	        }
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.seriesService.delete(rows.map(function (x) { return x.id; })).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0027');
	            _this.reflesh_list('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    SeriesController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    SeriesController.prototype.show = function () { };
	    return SeriesController;
	}(PjBaseController_1.PjBaseController));
	exports.SeriesController = SeriesController;
	var SeriesEditController = (function (_super) {
	    __extends(SeriesEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function SeriesEditController($stateParams, $uibModalInstance, $translate, pjInjectProxy, seriesService, $location, $scope, uiSortableMultiSelectionMethods, id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.seriesService = seriesService;
	        this.$location = $location;
	        this.$scope = $scope;
	        this.uiSortableMultiSelectionMethods = uiSortableMultiSelectionMethods;
	        this.id = id;
	        // 選択肢
	        this.selected = [];
	        // 登録対象
	        this.targets = [];
	        if (id) {
	            this.modalTitle = 'form26.title';
	            this.submitCaption = 'RC0000004';
	            this.seriesService.getRecord(id).then(function (data) {
	                _this.record = data.data.series;
	                //  メインカテゴリリスト取得
	                _this.seriesService.getSubCategoryList().then(function (editMainData) {
	                    $scope.mainCategoryList = editMainData.data.categories;
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	                //  this.record.videoIdから、登録済み動画をthis.targetsに描画する
	                //  this.record.groupIdの要素数を区切り、数をカウント
	                var videoStr = _this.record.videoId;
	                var videoIdAry = videoStr.split(',');
	                //  videotitleを格納
	                var videoTitleAry = _this.record.videoTitle;
	                //  配列結合
	                var inList = [];
	                for (var j = 0; j < videoIdAry.length; j++) {
	                    inList.push({ 'videoId': videoIdAry[j], 'title': videoTitleAry[j] });
	                }
	                //  選択済みリストを表示
	                _this.targets = inList;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.record = {};
	            this.modalTitle = 'form25.title';
	            this.submitCaption = 'RC0000002';
	            //  メインカテゴリリスト取得
	            this.seriesService.getSubCategoryList().then(function (newMainData) {
	                $scope.mainCategoryList = newMainData.data.categories;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        this.selected = [];
	        this.targets = [];
	        this.sortableOptions = uiSortableMultiSelectionMethods.extendOptions({
	            'axis ': 'y',
	            'cursorAt': { top: 25 },
	            'start': function (event, ui) {
	            },
	            'stop': function (event, ui) {
	            },
	            'connectWith': '.apps-container',
	            'placeholder': 'app',
	            'update': function (event, ui) {
	                if (ui.item.sortable.received) {
	                    return;
	                }
	                if (ui.item.sortable.sourceModel === _this.selected &&
	                    ui.item.sortable.droptargetModel === _this.targets) {
	                    var _loop_1 = function(i) {
	                        if (_this.targets.filter(function (x) { return x.videoId === ui.item.sortableMultiSelect.selectedModels[i].videoId; }).length) {
	                            ui.item.sortable.cancel();
	                            window.alert(_this.$translate.instant('message.0050'));
	                            return "break";
	                        }
	                    };
	                    for (var i = 0; i < ui.item.sortableMultiSelect.selectedModels.length; i++) {
	                        var state_1 = _loop_1(i);
	                        if (state_1 === "break") break;
	                    }
	                }
	            }
	        });
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	        if (this.isReadonly()) {
	            this.sortableOptions = {};
	        }
	    }
	    SeriesEditController.prototype.searchVideo = function () {
	        var _this = this;
	        this.selected = [];
	        var criteria = {
	            title: this.videoTitle,
	            subCategoryId: this.$scope.selectedItem || null
	        };
	        this.videoCriteria = criteria;
	        this.seriesService.getVideoList(this.videoCriteria).then(function (data) {
	            _this.clearAlert();
	            if (data.status === 204) {
	                _this.setAlert('message.0004');
	            }
	            else {
	                var dataLength = data.data.series.length;
	                _this.selected = data.data.series.splice(0, 100);
	                if (dataLength > 100) {
	                    _this.setAlert('message.0048');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    SeriesEditController.prototype.delete = function () {
	        var _this = this;
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.seriesService.delete([this.id]).then(function (data) {
	            _this.$uibModalInstance.close('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    SeriesEditController.prototype.update = function () {
	        var _this = this;
	        //  登録対象の動画重複チェック
	        var targetId = [];
	        var targetLen = this.targets.length || 0;
	        for (var i = 0; i < targetLen; i++) {
	            targetId.push(this.targets[i].videoId);
	        }
	        var c = targetId.filter(function (x, i, self) {
	            return self.indexOf(x) !== self.lastIndexOf(x);
	        });
	        if (c.length !== 0) {
	            console.log('NG');
	            //    window.alert(this.$translate.instant('message.0050'));
	            return;
	        }
	        this.record.videoId = this.targets.map(function (x) { return x.videoId; }).filter(function (x, i, self) {
	            return self.indexOf(x) === i && x !== '';
	        }).join(',');
	        if (this.id === null) {
	            this.seriesService.create(this.record).then(function (data) {
	                _this.$uibModalInstance.close('create');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.seriesService.update(this.record).then(function (data) {
	                _this.$uibModalInstance.close('update');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    SeriesEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    SeriesEditController.prototype.show = function () { };
	    return SeriesEditController;
	}(PjBaseController_1.PjBaseController));
	exports.SeriesEditController = SeriesEditController;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * シリーズ情報を管理する。
	 */
	var SeriesService = (function (_super) {
	    __extends(SeriesService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function SeriesService($q, seriesApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.seriesApi = seriesApi;
	    }
	    /**
	     * 検索
	     */
	    SeriesService.prototype.list = function (criteria) {
	        return this.seriesApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 取得
	     */
	    SeriesService.prototype.getRecord = function (id) {
	        return this.seriesApi.getRecord(id).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 更新
	     */
	    SeriesService.prototype.update = function (record) {
	        return this.seriesApi.update(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 登録
	     */
	    SeriesService.prototype.create = function (record) {
	        return this.seriesApi.create(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 削除
	     */
	    SeriesService.prototype.delete = function (ids) {
	        return this.seriesApi.delete(ids).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * サブカテゴリリスト取得
	     */
	    SeriesService.prototype.getSubCategoryList = function () {
	        return this.seriesApi.getSubCategoryList().then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 動画リスト取得
	     */
	    SeriesService.prototype.getVideoList = function (videoCriteria) {
	        return this.seriesApi.getVideoList(videoCriteria).then(function (data) {
	            return data;
	        });
	    };
	    return SeriesService;
	}(PjBaseService_1.PjBaseService));
	exports.SeriesService = SeriesService;


/***/ },
/* 69 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var SeriesApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function SeriesApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * シリーズの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    SeriesApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/series/search', criteria);
	    };
	    /**
	     * シリーズの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    SeriesApi.prototype.getRecord = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/series/' + id + '/edit', null);
	    };
	    /**
	     * シリーズの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    SeriesApi.prototype.update = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/series/update', record);
	    };
	    /**
	     * シリーズの情報を削除する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    SeriesApi.prototype.delete = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/series/delete', { ids: ids.join(',') });
	    };
	    /**
	     * シリーズの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    SeriesApi.prototype.create = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/series/create', record);
	    };
	    /**
	     * サブカテゴリの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    SeriesApi.prototype.getSubCategoryList = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/categories/subList', null);
	    };
	    /**
	     * 動画の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    SeriesApi.prototype.getVideoList = function (videoCriteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/series/editSearch', videoCriteria);
	    };
	    return SeriesApi;
	}());
	exports.SeriesApi = SeriesApi;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * パック画面について出力処理およびイベント処理を行う。
	 */
	var PackController = (function (_super) {
	    __extends(PackController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function PackController($stateParams, $window, $uibModal, $translate, pjInjectProxy, packService, $location, $http, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.packService = packService;
	        this.$location = $location;
	        this.$http = $http;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form27.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'title',
	                    displayName: 'item.0081',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.title}}</a>' + '<div>',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'videoCount',
	                    displayName: 'item.0108',
	                    width: '13%',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (!(auth.role === 3 || auth.role === 4)) {
	            this.$location.url('/top');
	        }
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    /**
	     * ダイアログ表示
	     */
	    PackController.prototype.show_dialog = function (id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/pack/edit.html',
	            controller: 'packEditController',
	            controllerAs: 'packEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	                _this.clearAlert();
	                if (result === 'delete') {
	                    _this.setAlert('message.0027');
	                }
	                _this.reflesh_list(result);
	            }
	        });
	    };
	    PackController.prototype.reflesh_list = function (result) {
	        var _this = this;
	        this.packService.list(this.criteria).then(function (data) {
	            _this.$scope.gridApi.selection.clearSelectedRows();
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.packs);
	            if (result !== 'delete') {
	                _this.clearAlert();
	                if (data.status === 204) {
	                    _this.setAlert('message.0004');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    PackController.prototype.search = function () {
	        var criteria = {
	            title: this.title
	        };
	        this.criteria = criteria;
	        this.reflesh_list('search');
	    };
	    PackController.prototype.delete = function () {
	        var _this = this;
	        var rows = this.$scope.gridApi.selection.getSelectedRows();
	        if (rows.length === 0) {
	            alert(this.$translate.instant('MC0000001'));
	            return;
	        }
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.packService.delete(rows.map(function (x) { return x.id; })).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0027');
	            _this.reflesh_list('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    PackController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    PackController.prototype.show = function () { };
	    return PackController;
	}(PjBaseController_1.PjBaseController));
	exports.PackController = PackController;
	var PackEditController = (function (_super) {
	    __extends(PackEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function PackEditController($stateParams, $uibModalInstance, $translate, pjInjectProxy, packService, $location, $scope, uiSortableMultiSelectionMethods, id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.packService = packService;
	        this.$location = $location;
	        this.$scope = $scope;
	        this.uiSortableMultiSelectionMethods = uiSortableMultiSelectionMethods;
	        this.id = id;
	        // 選択肢
	        this.selected = [];
	        // 登録対象
	        this.targets = [];
	        if (id) {
	            this.modalTitle = 'form29.title';
	            this.submitCaption = 'RC0000004';
	            this.packService.getRecord(id).then(function (data) {
	                _this.record = data.data.pack;
	                //  サブカテゴリリスト取得
	                _this.packService.getSubCategoryList().then(function (editMainData) {
	                    $scope.mainCategoryList = editMainData.data.categories;
	                }).catch(function (errorData) {
	                    _this.catch(errorData);
	                });
	                //  this.record.videoIdから、登録済み動画をthis.targetsに描画する
	                //  this.record.groupIdの要素数を区切り、数をカウント
	                var videoStr = _this.record.videoId;
	                var videoIdAry = videoStr.split(',');
	                //  videotitleを格納
	                var videoTitleAry = _this.record.videoTitle;
	                //  配列結合
	                var inList = [];
	                for (var j = 0; j < videoIdAry.length; j++) {
	                    inList.push({ 'videoId': videoIdAry[j], 'title': videoTitleAry[j] });
	                }
	                //  選択済みリストを表示
	                _this.targets = inList;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.record = {};
	            this.modalTitle = 'form28.title';
	            this.submitCaption = 'RC0000002';
	            //  サブカテゴリリスト取得
	            this.packService.getSubCategoryList().then(function (newMainData) {
	                $scope.mainCategoryList = newMainData.data.categories;
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        this.selected = [];
	        this.targets = [];
	        this.sortableOptions = uiSortableMultiSelectionMethods.extendOptions({
	            'axis ': 'y',
	            'cursorAt': { top: 25 },
	            'start': function (event, ui) {
	            },
	            'stop': function (event, ui) {
	            },
	            'connectWith': '.apps-container',
	            'placeholder': 'app',
	            'update': function (event, ui) {
	                if (ui.item.sortable.received) {
	                    return;
	                }
	                if (ui.item.sortable.sourceModel === _this.selected &&
	                    ui.item.sortable.droptargetModel === _this.targets) {
	                    var _loop_1 = function(i) {
	                        if (_this.targets.filter(function (x) { return x.videoId === ui.item.sortableMultiSelect.selectedModels[i].videoId; }).length) {
	                            ui.item.sortable.cancel();
	                            window.alert(_this.$translate.instant('message.0050'));
	                            return "break";
	                        }
	                    };
	                    for (var i = 0; i < ui.item.sortableMultiSelect.selectedModels.length; i++) {
	                        var state_1 = _loop_1(i);
	                        if (state_1 === "break") break;
	                    }
	                }
	            }
	        });
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	        if (this.isReadonly()) {
	            this.sortableOptions = {};
	        }
	    }
	    PackEditController.prototype.searchVideo = function () {
	        var _this = this;
	        this.selected = [];
	        var criteria = {
	            title: this.videoTitle,
	            subCategoryId: this.$scope.selectedItem || null
	        };
	        this.videoCriteria = criteria;
	        this.packService.getVideoList(this.videoCriteria).then(function (data) {
	            _this.clearAlert();
	            if (data.status === 204) {
	                _this.setAlert('message.0004');
	            }
	            else {
	                var dataLength = data.data.packs.length;
	                _this.selected = data.data.packs.splice(0, 100);
	                if (dataLength > 100) {
	                    _this.setAlert('message.0048');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    PackEditController.prototype.delete = function () {
	        var _this = this;
	        if (!window.confirm(this.$translate.instant('CC0000001'))) {
	            return;
	        }
	        this.packService.delete([this.id]).then(function (data) {
	            _this.$uibModalInstance.close('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    PackEditController.prototype.update = function () {
	        var _this = this;
	        //  登録対象の動画重複チェック
	        var targetId = [];
	        var targetLen = this.targets.length || 0;
	        for (var i = 0; i < targetLen; i++) {
	            targetId.push(this.targets[i].videoId);
	        }
	        var c = targetId.filter(function (x, i, self) {
	            return self.indexOf(x) !== self.lastIndexOf(x);
	        });
	        if (c.length !== 0) {
	            console.log('NG');
	            //    window.alert(this.$translate.instant('message.0050'));
	            return;
	        }
	        this.record.videoId = this.targets.map(function (x) { return x.videoId; }).filter(function (x, i, self) {
	            return self.indexOf(x) === i && x !== '';
	        }).join(',');
	        if (this.id === null) {
	            this.packService.create(this.record).then(function (data) {
	                _this.$uibModalInstance.close('create');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.packService.update(this.record).then(function (data) {
	                _this.$uibModalInstance.close('update');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    PackEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    PackEditController.prototype.show = function () { };
	    return PackEditController;
	}(PjBaseController_1.PjBaseController));
	exports.PackEditController = PackEditController;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * パック情報を管理する。
	 */
	var PackService = (function (_super) {
	    __extends(PackService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function PackService($q, packApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.packApi = packApi;
	    }
	    /**
	     * 検索
	     */
	    PackService.prototype.list = function (criteria) {
	        return this.packApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 取得
	     */
	    PackService.prototype.getRecord = function (id) {
	        return this.packApi.getRecord(id).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 更新
	     */
	    PackService.prototype.update = function (record) {
	        return this.packApi.update(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 登録
	     */
	    PackService.prototype.create = function (record) {
	        return this.packApi.create(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 削除
	     */
	    PackService.prototype.delete = function (ids) {
	        return this.packApi.delete(ids).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * メインカテゴリリスト取得
	     */
	    PackService.prototype.getSubCategoryList = function () {
	        return this.packApi.getSubCategoryList().then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 動画リスト取得
	     */
	    PackService.prototype.getVideoList = function (videoCriteria) {
	        return this.packApi.getVideoList(videoCriteria).then(function (data) {
	            return data;
	        });
	    };
	    return PackService;
	}(PjBaseService_1.PjBaseService));
	exports.PackService = PackService;


/***/ },
/* 72 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var PackApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function PackApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * パックの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    PackApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/packs/search', criteria);
	    };
	    /**
	     * パックの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    PackApi.prototype.getRecord = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/packs/' + id + '/edit', null);
	    };
	    /**
	     * パックの情報を更新する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    PackApi.prototype.update = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/packs/update', record);
	    };
	    /**
	     * パックの情報を削除する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    PackApi.prototype.delete = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/packs/delete', { ids: ids.join(',') });
	    };
	    /**
	     * パックの情報を登録する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    PackApi.prototype.create = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/packs/create', record);
	    };
	    /**
	     * メインカテゴリの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    PackApi.prototype.getSubCategoryList = function (isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/categories/subList', null);
	    };
	    /**
	     * 動画の情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    PackApi.prototype.getVideoList = function (videoCriteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/packs/editSearch', videoCriteria);
	    };
	    return PackApi;
	}());
	exports.PackApi = PackApi;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * お知らせ画面について出力処理およびイベント処理を行う。
	 */
	var NoticeController = (function (_super) {
	    __extends(NoticeController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function NoticeController($stateParams, $window, $uibModal, $translate, pjInjectProxy, noticeService, $location, $http, sharedService, $scope) {
	        var _this = this;
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.noticeService = noticeService;
	        this.$location = $location;
	        this.$http = $http;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form30.title');
	        this.gridOptions = {
	            columnDefs: [
	                {
	                    field: 'title',
	                    displayName: 'item.0038',
	                    cellTemplate: '<div class="ui-grid-cell-contents" style="padding:5px">' + '<a ng-click="grid.appScope.show(row.entity.id)">{{row.entity.title}}</a>' + '<div>',
	                    headerCellFilter: 'translate'
	                },
	                {
	                    field: 'date',
	                    displayName: 'item.0039',
	                    width: '13%',
	                    headerCellFilter: 'translate'
	                }
	            ],
	            enableRowSelection: true,
	            enableSelectAll: true,
	            enableColumnMenus: false,
	            enableHorizontalScrollbar: 0,
	            enableColumnResizing: true,
	            paginationPageSizes: [10, 25, 100],
	            paginationPageSize: 10,
	            onRegisterApi: function (gridApi) {
	                _this.$scope.gridApi = gridApi;
	            },
	        };
	        this.draw();
	        this.$scope.show = function (id) {
	            return _this.show_dialog(id);
	        };
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (!(auth.role === 3 || auth.role === 4)) {
	            this.$location.url('/top');
	        }
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    /**
	     * ダイアログ表示
	     */
	    NoticeController.prototype.show_dialog = function (id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        var test = this.$uibModal.open({
	            templateUrl: 'template/notice/edit.html',
	            controller: 'noticeEditController',
	            controllerAs: 'noticeEdit',
	            resolve: {
	                id: function () {
	                    return id;
	                }
	            },
	        }).result.then(function (result) {
	            if (result) {
	                _this.clearAlert();
	                if (result === 'delete') {
	                    _this.setAlert('message.0027');
	                }
	                _this.reflesh_list(result);
	            }
	        });
	    };
	    NoticeController.prototype.reflesh_list = function (result) {
	        var _this = this;
	        this.noticeService.list(this.criteria).then(function (data) {
	            _this.$scope.gridApi.selection.clearSelectedRows();
	            _this.gridOptions.data.splice(0, _this.gridOptions.data.length);
	            Array.prototype.push.apply(_this.gridOptions.data, data.data.notices);
	            if (result !== 'delete') {
	                _this.clearAlert();
	                if (data.status === 204) {
	                    _this.setAlert('message.0004');
	                }
	            }
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 検索処理
	     */
	    NoticeController.prototype.search = function () {
	        var criteria = {
	            title: this.title,
	            description: this.description,
	            date: this.date,
	            dateFlg: 0
	        };
	        this.criteria = criteria;
	        this.reflesh_list('search');
	    };
	    NoticeController.prototype.delete = function () {
	        var _this = this;
	        var rows = this.$scope.gridApi.selection.getSelectedRows();
	        if (rows.length === 0) {
	            alert(this.$translate.instant('message.0002'));
	            return;
	        }
	        if (!window.confirm(this.$translate.instant('message.0001'))) {
	            return;
	        }
	        this.noticeService.delete(rows.map(function (x) { return x.id; })).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0027');
	            _this.reflesh_list('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    NoticeController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    NoticeController.prototype.show = function () { };
	    return NoticeController;
	}(PjBaseController_1.PjBaseController));
	exports.NoticeController = NoticeController;
	var NoticeEditController = (function (_super) {
	    __extends(NoticeEditController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function NoticeEditController($stateParams, $uibModalInstance, $translate, pjInjectProxy, noticeService, $location, $scope, id) {
	        var _this = this;
	        if (id === void 0) { id = null; }
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$uibModalInstance = $uibModalInstance;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.noticeService = noticeService;
	        this.$location = $location;
	        this.$scope = $scope;
	        this.id = id;
	        if (id) {
	            this.modalTitle = 'form32.title';
	            this.submitCaption = 'item.0040';
	            this.noticeService.getRecord(id).then(function (data) {
	                _this.record = data.data.notice;
	                _this.record.date = new Date(_this.record.date);
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.record = {};
	            this.modalTitle = 'form31.title';
	            this.submitCaption = 'item.0067';
	        }
	        //  項目の表示制御(トーマツ)
	        $scope.tohmatsu = this.isTohmatsu();
	        //  読み取り専用か判定
	        $scope.readUser = this.isReadonly();
	        $scope.readUserBtn = !this.isReadonly();
	    }
	    NoticeEditController.prototype.delete = function () {
	        var _this = this;
	        if (!window.confirm(this.$translate.instant('message.0001'))) {
	            return;
	        }
	        this.noticeService.delete([this.id]).then(function (data) {
	            _this.$uibModalInstance.close('delete');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    NoticeEditController.prototype.update = function () {
	        var _this = this;
	        if (this.id === null) {
	            this.noticeService.create(this.record).then(function (data) {
	                _this.$uibModalInstance.close('create');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	        else {
	            this.noticeService.update(this.record).then(function (data) {
	                _this.$uibModalInstance.close('update');
	            }).catch(function (errorData) {
	                _this.catch(errorData);
	            });
	        }
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    NoticeEditController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    NoticeEditController.prototype.show = function () { };
	    return NoticeEditController;
	}(PjBaseController_1.PjBaseController));
	exports.NoticeEditController = NoticeEditController;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * お知らせ情報を管理する。
	 */
	var NoticeService = (function (_super) {
	    __extends(NoticeService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function NoticeService($q, noticeApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.noticeApi = noticeApi;
	    }
	    /**
	     * 検索
	     */
	    NoticeService.prototype.list = function (criteria) {
	        return this.noticeApi.list(criteria).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 取得
	     */
	    NoticeService.prototype.getRecord = function (id) {
	        return this.noticeApi.getRecord(id).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 更新
	     */
	    NoticeService.prototype.update = function (record) {
	        return this.noticeApi.update(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 登録
	     */
	    NoticeService.prototype.create = function (record) {
	        return this.noticeApi.create(record).then(function (data) {
	            return data;
	        });
	    };
	    /**
	     * 削除
	     */
	    NoticeService.prototype.delete = function (ids) {
	        return this.noticeApi.delete(ids).then(function (data) {
	            return data;
	        });
	    };
	    return NoticeService;
	}(PjBaseService_1.PjBaseService));
	exports.NoticeService = NoticeService;


/***/ },
/* 75 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var NoticeApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function NoticeApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * お知らせの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    NoticeApi.prototype.list = function (criteria, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/notices/search', criteria);
	    };
	    /**
	     * お知らせの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    NoticeApi.prototype.getRecord = function (id, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.get('/notices/' + id + '/edit', null);
	    };
	    /**
	     * お知らせの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    NoticeApi.prototype.update = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/notices/update', record);
	    };
	    /**
	     * お知らせの情報を削除する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    NoticeApi.prototype.delete = function (ids, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/notices/delete', { ids: ids.join(',') });
	    };
	    /**
	     * お知らせの情報を取得する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    NoticeApi.prototype.create = function (record, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/notices/create', record);
	    };
	    return NoticeApi;
	}());
	exports.NoticeApi = NoticeApi;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * ユーザ取込画面について出力処理およびイベント処理を行う。
	 */
	var UserCapController = (function (_super) {
	    __extends(UserCapController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function UserCapController($stateParams, $window, $uibModal, $translate, pjInjectProxy, userCapService, $location, sharedService, $scope) {
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.userCapService = userCapService;
	        this.$location = $location;
	        this.sharedService = sharedService;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form08.title');
	        this.setMenu(true);
	        //  sharedService
	        var auth;
	        auth = sharedService.get('auth');
	        //  権限が無いユーザはTOPへ戻す
	        if (auth.role !== 2) {
	            this.$location.url('/top');
	        }
	    }
	    UserCapController.prototype.insert = function () {
	        var _this = this;
	        this.clearAlert();
	        this.userCapService.insert(this.csvFile).then(function (data) {
	            _this.setAlert('message.0023');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    UserCapController.prototype.close = function () {
	        this.$location.url('/user');
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    UserCapController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    UserCapController.prototype.show = function () { };
	    return UserCapController;
	}(PjBaseController_1.PjBaseController));
	exports.UserCapController = UserCapController;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * ユーザ取込情報を管理する。
	 */
	var UserCapService = (function (_super) {
	    __extends(UserCapService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function UserCapService($q, userCapApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.userCapApi = userCapApi;
	    }
	    /**
	     * CSV送信
	     */
	    UserCapService.prototype.insert = function (csvFile) {
	        return this.userCapApi.insert(csvFile).then(function (data) {
	            return data;
	        });
	    };
	    return UserCapService;
	}(PjBaseService_1.PjBaseService));
	exports.UserCapService = UserCapService;


/***/ },
/* 78 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var UserCapApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function UserCapApi($http, $q, $httpParamSerializer, basePath, $net, Upload) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        this.Upload = Upload;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * ユーザCSVを送信する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    UserCapApi.prototype.insert = function (file, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.Upload.upload({
	            url: this.basePath + '/users/insert',
	            data: { file: file }
	        });
	    };
	    return UserCapApi;
	}());
	exports.UserCapApi = UserCapApi;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * パスワード画面について出力処理およびイベント処理を行う。
	 */
	var PasswordController = (function (_super) {
	    __extends(PasswordController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function PasswordController($stateParams, $window, $uibModal, $translate, pjInjectProxy, passwordService, $location, $scope) {
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.passwordService = passwordService;
	        this.$location = $location;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        this.setTitle('form33.title');
	    }
	    PasswordController.prototype.updatePassword = function () {
	        var _this = this;
	        var pass = {
	            password: this.password
	        };
	        this.upPassword = pass;
	        this.passwordService.updatePassword(this.upPassword).then(function (data) {
	            _this.clearAlert();
	            _this.setAlert('message.0029');
	        }).catch(function (errorData) {
	            _this.catch(errorData);
	        });
	    };
	    PasswordController.prototype.passwordChanged = function () {
	        this.$scope.$broadcast('angularValidation.revalidate', 'passwordRe');
	    };
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    PasswordController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    PasswordController.prototype.show = function () { };
	    return PasswordController;
	}(PjBaseController_1.PjBaseController));
	exports.PasswordController = PasswordController;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseService_1 = __webpack_require__(6);
	/**
	 * パスワード情報を管理する。
	 */
	var PasswordService = (function (_super) {
	    __extends(PasswordService, _super);
	    /**
	     * コンストラクタ
	     * @param {ng.IQService} $q 非同期サービス
	     * @param {AuthorApi} authorApi 著者API
	     */
	    /* @ngInject */
	    function PasswordService($q, passwordApi) {
	        _super.call(this, null);
	        this.$q = $q;
	        this.passwordApi = passwordApi;
	    }
	    /**
	     * パスワード更新
	     */
	    PasswordService.prototype.updatePassword = function (password) {
	        return this.passwordApi.updatePassword(password).then(function (data) {
	            return data;
	        });
	    };
	    return PasswordService;
	}(PjBaseService_1.PjBaseService));
	exports.PasswordService = PasswordService;


/***/ },
/* 81 */
/***/ function(module, exports) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var PasswordApi = (function () {
	    /**
	     * コンストラクタ
	     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
	     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
	     * @param { string } basePath ベースパスを設定する
	     */
	    function PasswordApi($http, $q, $httpParamSerializer, basePath, $net) {
	        this.$http = $http;
	        this.$q = $q;
	        this.$httpParamSerializer = $httpParamSerializer;
	        this.$net = $net;
	        /**
	         * Base Pathの設定。デフォルトは「/」
	         */
	        this.basePath = '/';
	        if (basePath) {
	            this.basePath = basePath;
	        }
	    }
	    /**
	     * パスワードの情報を更新する。
	     * @param authorCode  著者コード
	     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
	     * @return Promiseを返す
	     */
	    PasswordApi.prototype.updatePassword = function (password, isDbl) {
	        if (isDbl === void 0) { isDbl = true; }
	        return this.$net.post('/users/updatePassword', password);
	    };
	    return PasswordApi;
	}());
	exports.PasswordApi = PasswordApi;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * ALL RIGHTS RESERVED,
	 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
	 */
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var PjBaseController_1 = __webpack_require__(22);
	/**
	 * reload処理の代わりに空ページを挟む
	 */
	var BlankController = (function (_super) {
	    __extends(BlankController, _super);
	    /**
	     * コンストラクタ
	     */
	    /* @ngInject */
	    function BlankController($stateParams, $window, $uibModal, $translate, pjInjectProxy, $location, $scope) {
	        _super.call(this, $stateParams, $translate, $location, pjInjectProxy);
	        this.$stateParams = $stateParams;
	        this.$window = $window;
	        this.$uibModal = $uibModal;
	        this.$translate = $translate;
	        this.pjInjectProxy = pjInjectProxy;
	        this.$location = $location;
	        this.$scope = $scope;
	        if (!this.checkAuthenticatedUser()) {
	            return;
	        }
	        var path = '/' + $stateParams.go;
	        this.$location.url(path);
	    }
	    /**
	     * 復元処理
	     * @param {any} data 復元用データ
	     */
	    BlankController.prototype.restore = function (data) { };
	    /**
	     * 表示処理
	     */
	    BlankController.prototype.show = function () { };
	    return BlankController;
	}(PjBaseController_1.PjBaseController));
	exports.BlankController = BlankController;


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** ma/app.js
 **/